webpackJsonp([1],{

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var baseUri = 'attachments';

/* harmony default export */ __webpack_exports__["a"] = ({
  store: function store(data) {
    return api.post('' + baseUri, data);
  },
  remove: function remove(id) {
    return api.delete(baseUri + '/' + id);
  }
});

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_views_App__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_views_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__js_views_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_router__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_bootstrap__ = __webpack_require__(328);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

var data = {
  cart: null
};

/* eslint-disable no-new */
window.vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  data: data,
  router: __WEBPACK_IMPORTED_MODULE_2__js_router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__js_views_App___default.a }
});

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var baseUri = 'categories';

/* harmony default export */ __webpack_exports__["a"] = ({
  show: function show(slug) {
    return api.get(baseUri + '/' + slug);
  }
});

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var baseUri = 'delivery-addresses';

/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index(query, limit, cancelToken) {
    return api.get(baseUri, {
      params: {
        query: query,
        limit: limit
      },
      cancelToken: cancelToken
    });
  }
});

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var baseUri = 'notifications';

/* harmony default export */ __webpack_exports__["a"] = ({
  sendOrderClientSummary: function sendOrderClientSummary(orderId, email) {
    var data = {
      order_id: orderId,
      email: email
    };

    return api.post(baseUri + '/order-client-summary', data);
  }
});

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var baseUri = 'products';

/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index(query, limit, cancelToken) {
    return api.get(baseUri, {
      params: {
        query: query,
        limit: limit
      },
      cancelToken: cancelToken
    });
  },
  show: function show(id) {
    return api.get(baseUri + '/' + id);
  }
});

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var baseUri = 'product-prices';

/* harmony default export */ __webpack_exports__["a"] = ({
  create: function create(data, cancelToken) {
    return api.post('' + baseUri, data, {
      cancelToken: cancelToken
    });
  }
});

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_locale_nb__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment_locale_nb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment_locale_nb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lightbox2_dist_css_lightbox_min_css__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lightbox2_dist_css_lightbox_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lightbox2_dist_css_lightbox_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_basscss_css_basscss_min_css__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_basscss_css_basscss_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_basscss_css_basscss_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scss_app_scss__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scss_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__scss_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helper__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__helper__);
/* eslint-disable import/first */

// Axios and authentication


// Vue.js


// Vue Material



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_material___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].material.registerTheme({
  default: {
    primary: {
      color: 'light-blue',
      hue: 'A700'
    },
    accent: 'blue',
    warn: 'red'
  },
  white: {
    primary: 'white',
    accent: 'blue'
  }
});

// moment


window.moment = __WEBPACK_IMPORTED_MODULE_4_moment___default.a;
__WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale('nb');

// lodash
window._ = __webpack_require__(611);

// Lightbox 2

var lightbox = __webpack_require__(610);

lightbox.option({
  wrapAround: true
});

// Basscss


// Application styles


// Components


// Helpers


/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_components_md_Notification__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_components_md_Notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__js_components_md_Notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_components_myo_Sidebar__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_components_myo_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__js_components_myo_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_components_myo_Input__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_components_myo_Input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__js_components_myo_Input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_components_myo_Parameters__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_components_myo_Parameters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__js_components_myo_Parameters__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('md-notification', __WEBPACK_IMPORTED_MODULE_1__js_components_md_Notification___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('myo-sidebar', __WEBPACK_IMPORTED_MODULE_2__js_components_myo_Sidebar___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('myo-input', __WEBPACK_IMPORTED_MODULE_3__js_components_myo_Input___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('myo-parameters', __WEBPACK_IMPORTED_MODULE_4__js_components_myo_Parameters___default.a);

/***/ }),

/***/ 330:
/***/ (function(module, exports) {

window.snack = function (message) {
  vm.$children[0].snackbar(message);
};

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_auth__ = __webpack_require__(68);




window.axios = __WEBPACK_IMPORTED_MODULE_1_axios___default.a;

// Set default headers
var headers = {
  Accept: 'application/json'
};

// Configure axios API instance
window.api = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL: "https://staples-api.myorder.no/v1/",
  headers: headers
});

// Request interseptor
api.interceptors.request.use(function (config) {
  if (__WEBPACK_IMPORTED_MODULE_2__api_auth__["a" /* default */].isAuthenticated()) {
    config.headers.Authorization = 'Bearer ' + __WEBPACK_IMPORTED_MODULE_2__api_auth__["a" /* default */].getToken();
  }

  return config;
}, function (error) {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

// Response interseptor
api.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response !== undefined) {
    if (error.response.status === 401 && __WEBPACK_IMPORTED_MODULE_2__api_auth__["a" /* default */].isAuthenticated()) {
      __WEBPACK_IMPORTED_MODULE_2__api_auth__["a" /* default */].logout();
      location.reload();
    }

    if (error.response.data.message !== undefined) {
      vm.$children[0].snackbar(error.response.data.message);
    }
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    openDialog: function openDialog(ref) {
      this.$refs[ref].open();
    },
    closeDialog: function closeDialog(ref) {
      this.$refs[ref].close();
    }
  }
});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_api_auth__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_views_auth_Login__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_views_auth_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__js_views_auth_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_views_auth_Logout__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_views_auth_Logout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__js_views_auth_Logout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_views_templates_Main__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_views_templates_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__js_views_templates_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__js_views_templates_Shop__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__js_views_templates_Shop___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__js_views_templates_Shop__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__js_views_shop_ProductCategory__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__js_views_shop_ProductCategory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__js_views_shop_ProductCategory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__js_views_shop_Product__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__js_views_shop_Product___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__js_views_shop_Product__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__js_views_shop_Cart__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__js_views_shop_Cart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__js_views_shop_Cart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__js_views_shop_Checkout__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__js_views_shop_Checkout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__js_views_shop_Checkout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__js_views_shop_MyOrders__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__js_views_shop_MyOrders___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__js_views_shop_MyOrders__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__js_views_shop_ViewOrder__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__js_views_shop_ViewOrder___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__js_views_shop_ViewOrder__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__js_views_shop_OrderComplete__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__js_views_shop_OrderComplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__js_views_shop_OrderComplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__js_views_templates_Settings__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__js_views_templates_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__js_views_templates_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__js_views_settings_MyProfile__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__js_views_settings_MyProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__js_views_settings_MyProfile__);




















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var beforeEach = function beforeEach(to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.auth;
  })) {
    if (!__WEBPACK_IMPORTED_MODULE_2__js_api_auth__["a" /* default */].isAuthenticated()) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next();
  }
};

var routes = [{
  path: '/',
  redirect: '/app'
}, {
  path: '/login',
  name: 'login',
  component: __WEBPACK_IMPORTED_MODULE_3__js_views_auth_Login___default.a
}, {
  path: '/logout',
  name: 'logout',
  component: __WEBPACK_IMPORTED_MODULE_4__js_views_auth_Logout___default.a
}, {
  path: '/app',
  component: __WEBPACK_IMPORTED_MODULE_5__js_views_templates_Main___default.a,
  redirect: '/app/shop',
  meta: { auth: true },
  children: [{
    path: 'shop',
    name: 'shop',
    component: __WEBPACK_IMPORTED_MODULE_6__js_views_templates_Shop___default.a,
    redirect: '/app/shop/category/all',
    children: [{
      path: 'category/:categoryId',
      name: 'category',
      component: __WEBPACK_IMPORTED_MODULE_7__js_views_shop_ProductCategory___default.a
    }, {
      path: 'product/:productId',
      name: 'view-product',
      component: __WEBPACK_IMPORTED_MODULE_8__js_views_shop_Product___default.a
    }, {
      path: 'cart',
      name: 'cart',
      component: __WEBPACK_IMPORTED_MODULE_9__js_views_shop_Cart___default.a
    }, {
      path: 'checkout',
      name: 'checkout',
      component: __WEBPACK_IMPORTED_MODULE_10__js_views_shop_Checkout___default.a
    }, {
      path: 'my-orders',
      name: 'my-orders',
      component: __WEBPACK_IMPORTED_MODULE_11__js_views_shop_MyOrders___default.a
    }, {
      path: 'order-complete/:orderId',
      name: 'order-complete',
      component: __WEBPACK_IMPORTED_MODULE_13__js_views_shop_OrderComplete___default.a
    }, {
      path: 'my-orders/:orderId',
      name: 'view-order',
      component: __WEBPACK_IMPORTED_MODULE_12__js_views_shop_ViewOrder___default.a
    }]
  }, {
    path: 'settings',
    name: 'settings',
    component: __WEBPACK_IMPORTED_MODULE_14__js_views_templates_Settings___default.a,
    redirect: '/app/settings/my-profile',
    children: [{
      path: 'my-profile',
      name: 'my-profile',
      component: __WEBPACK_IMPORTED_MODULE_15__js_views_settings_MyProfile___default.a
    }]
  }]
}];

var RouterInstance = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes
});

RouterInstance.beforeEach(beforeEach);

/* harmony default export */ __webpack_exports__["a"] = (RouterInstance);

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: {},
    clearable: {},
    maxlength: {},
    name: {},
    autocomplete: {},
    placeholder: '',
    disabled: false,
    type: {
      default: 'text'
    }
  },

  methods: {
    updateValue: function updateValue(value) {
      this.$emit('input', value);
    },
    clear: function clear() {
      this.$emit('input', '');
    }
  }
});

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: {}
  },

  data: function data() {
    return {
      parameters: {}
    };
  },
  mounted: function mounted() {
    this.initParameters();
    this.$emit('loaded');
  },


  methods: {
    initParameters: function initParameters() {
      switch (this.type) {
        case 'beachflag':
          this.parameters = {
            size: 'medium',
            shape: 'normal'
          };
          break;

        case 'banner':
          this.parameters = {
            width: '100',
            height: '100',
            features: {
              material: 'pvc'
            },
            extra: {
              holes: false,
              rubber_bands: 0
            }
          };
          break;

        case 'alu-plate':
          this.parameters = {
            width: '100',
            height: '100',
            features: {
              thickness: '3'
            },
            extra: {
              holes: false,
              cut_to_shape: false
            }
          };
          break;

        case 'pvc-plate':
          this.parameters = {
            width: '100',
            height: '100',
            features: {
              thickness: '3'
            },
            extra: {
              holes: false,
              cut_to_shape: false
            }
          };
          break;

        case 'flex-wall':
          this.parameters = {
            width: '130',
            height: '81',
            features: {
              sides: 'single'
            },
            extra: {
              system: true
            }
          };
          break;

        case 'curved-pop-up-wall':
          this.parameters = {
            type: 'curved'
          };
          break;

        case 'digital-booklet':
          this.parameters = {
            pages: 8
          };
          break;

        case 'expo-tent':
          this.parameters = {
            type: '300x300'
          };
          break;

        case 'alu-frame':
          this.parameters = {
            size: 'A4'
          };
          break;

        case 'l-banner':
          this.parameters = {
            type: 'single-75x200'
          };
          break;

        case 'l-banner-graphics':
          this.parameters = {
            size: '75x200'
          };
          break;

        case 'x-banner':
          this.parameters = {
            size: '80x180'
          };
          break;

        case 'canvas':
          this.parameters = {
            size: 'A4'
          };
          break;

        case 'x-banner-graphics':
          this.parameters = {
            size: '80x180'
          };
          break;

        default:
          this.parameters = {};
          break;
      }
    },
    updateExtra: function updateExtra() {
      if (this.type === 'banner') {
        if (this.parameters.extra.holes) {
          var rubberBands = (Math.ceil(this.parameters.width / 100) + 1) * 2;
          console.log(rubberBands);
          rubberBands += (Math.ceil(this.parameters.height / 100) - 1) * 2;
          console.log(rubberBands);
          this.parameters.extra.rubber_bands = rubberBands;
        } else {
          this.parameters.extra.rubber_bands = 0;
        }
      }

      if (this.type === 'banner') {
        if (this.parameters.extra.holes) {
          var _rubberBands = (Math.ceil(this.parameters.width / 100) + 1) * 2;
          console.log(_rubberBands);
          _rubberBands += (Math.ceil(this.parameters.height / 100) - 1) * 2;
          console.log(_rubberBands);
          this.parameters.extra.rubber_bands = _rubberBands;
        } else {
          this.parameters.extra.rubber_bands = 0;
        }
      }
    }
  },

  watch: {
    parameters: {
      deep: true,
      handler: function handler(value) {
        this.$emit('changed', value);
      }
    },
    'parameters.width': {
      handler: function handler(value) {
        this.updateExtra();
      }
    },
    'parameters.height': {
      handler: function handler(value) {
        this.updateExtra();
      }
    },
    'parameters.extra.holes': {
      handler: function handler(value) {
        this.updateExtra();
      }
    }
  }
});

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',

  data: function data() {
    return {
      snackbarMessage: ''
    };
  },


  methods: {
    snackbar: function snackbar(message) {
      this.snackbarMessage = message;
      this.$refs.snackbar.open();
    }
  }
});

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_helpers_state__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_helpers_errors__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_api_auth__ = __webpack_require__(68);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      state: new __WEBPACK_IMPORTED_MODULE_0__js_helpers_state__["a" /* default */](),
      errors: new __WEBPACK_IMPORTED_MODULE_1__js_helpers_errors__["a" /* default */](),
      username: '',
      password: '',
      remember: true
    };
  },
  mounted: function mounted() {
    if (__WEBPACK_IMPORTED_MODULE_2__js_api_auth__["a" /* default */].isAuthenticated()) {
      this.$router.push('/');
    }
  },


  methods: {
    login: function login() {
      var _this = this;

      this.state.start('authenticating');

      __WEBPACK_IMPORTED_MODULE_2__js_api_auth__["a" /* default */].authenticate({
        username: this.username,
        password: this.password,
        remember: this.remember
      }).then(function () {
        if (_this.$route.query.redirect !== undefined) {
          _this.$router.push(_this.$route.query.redirect);
        } else {
          _this.$router.push('/');
        }
      }).catch(function (error) {
        _this.state.stop('authenticating');

        var errors = {};

        if (error.response.data.errors !== undefined) {
          errors = error.response.data.errors;
        }

        if (error.response.data.error !== 'validation_error') {
          errors.login = [error.response.data.message];
        }

        _this.errors.setErrors(errors);
      }).then(function () {
        _this.state.stop('authenticating');
      });
    }
  }
});

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_api_auth__ = __webpack_require__(68);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0__js_api_auth__["a" /* default */].logout();
    this.$root.$data.user = undefined;
    this.$router.push('login');
  }
});

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_api_me__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_helpers_errors__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helpers_state__ = __webpack_require__(38);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      state: new __WEBPACK_IMPORTED_MODULE_3__js_helpers_state__["a" /* default */](),
      errors: new __WEBPACK_IMPORTED_MODULE_2__js_helpers_errors__["a" /* default */](),
      user: {},
      password: {}
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__js_api_me__["a" /* default */].show().then(this.onFetchSuccess).catch(this.onError);
  },


  methods: {
    save: function save() {
      var _this = this;

      this.state.start('saving');
      this.errors.clearErrors();

      __WEBPACK_IMPORTED_MODULE_1__js_api_me__["a" /* default */].update(this.user).then(this.onSaveSuccess).catch(this.onError).then(function () {
        _this.state.stop('saving');
      });
    },
    savePassword: function savePassword() {
      var _this2 = this;

      this.state.start('saving-password');
      this.errors.clearErrors();

      var data = {
        password: this.password.new,
        password_confirm: this.password.newConfirm,
        password_old: this.password.old
      };

      __WEBPACK_IMPORTED_MODULE_1__js_api_me__["a" /* default */].update(data).then(this.onUpdatePasswordSuccess).catch(this.onError).then(function () {
        _this2.state.stop('saving-password');
      });
    },
    onFetchSuccess: function onFetchSuccess(response) {
      this.user = response.data.data;
    },
    onSaveSuccess: function onSaveSuccess(response) {
      snack('Personlig informasjon oppdatert!');

      this.user = response.data.data;
      this.$root.$data.user = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data.data));
    },
    onUpdatePasswordSuccess: function onUpdatePasswordSuccess(response) {
      snack('Passord oppdatert!');

      this.password.new = '';
      this.password.newConfirm = '';
      this.password.old = '';
    },
    onError: function onError(error) {
      if (error.response !== undefined) {
        this.errors.setErrors(error.response.data.errors);
      }
    }
  }
});

/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    toLocale: function toLocale(value) {
      if (value === null) {
        return null;
      }

      var number = parseFloat(value);
      return number.toLocaleString();
    }
  }
});

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_api_cart__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_api_cartItem__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_helpers_state__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_mixins_hasPrices__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_mixins_hasPictures__ = __webpack_require__(58);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__js_mixins_hasPrices__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__js_mixins_hasPictures__["a" /* default */]],

  data: function data() {
    return {
      state: new __WEBPACK_IMPORTED_MODULE_2__js_helpers_state__["a" /* default */](),
      cart: null
    };
  },
  mounted: function mounted() {
    // this.state.start('loading');
    __WEBPACK_IMPORTED_MODULE_0__js_api_cart__["a" /* default */].get().then(this.onCartSuccess);
  },


  methods: {
    onCartSuccess: function onCartSuccess(cart) {
      __WEBPACK_IMPORTED_MODULE_0__js_api_cart__["a" /* default */].show(cart.id).then(this.onFetchSuccess);
    },
    onFetchSuccess: function onFetchSuccess(response) {
      this.$root.$data.cart = response.data.data;
      // this.state.stop('loading');
    },
    removeItem: function removeItem(index) {
      var _this = this;

      var item = this.$root.$data.cart.items[index];

      return __WEBPACK_IMPORTED_MODULE_1__js_api_cartItem__["a" /* default */].remove(item.id).then(function (response) {
        _this.$root.$data.cart.items.splice(index, 1);

        var newTotals = response.data.meta.cart_totals;

        _this.$root.$data.cart.gross_total = newTotals.gross_total;
        _this.$root.$data.cart.vat_totals = newTotals.vat_totals;
        _this.$root.$data.cart.net_totals = newTotals.net_totals;
      });
    },
    updateItem: function updateItem(index) {
      var item = this.$root.$data.cart.items[index];

      if (item.quantity === 0) {
        this.removeItem(index);
      } else {
        var data = {
          quantity: item.quantity
        };

        __WEBPACK_IMPORTED_MODULE_1__js_api_cartItem__["a" /* default */].update(item.id, data).then(this.onItemUpdateSuccess);
      }
    },
    onItemUpdateSuccess: function onItemUpdateSuccess(response) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0__js_api_cart__["a" /* default */].refresh().then(function (cart) {
        _this2.$root.$data.cart = cart;
      });
    },
    viewProduct: function viewProduct(id) {
      this.$router.push({ name: 'view-product', params: { productId: id } });
    },
    goToCheckout: function goToCheckout() {
      this.$router.push({ name: 'checkout' });
    },
    goToShop: function goToShop() {
      this.$router.push({ name: 'shop' });
    },
    goBack: function goBack() {
      this.$router.go(-1);
    },
    emptyCart: function emptyCart() {
      var _this3 = this;

      this.state.start('emptying-cart');
      var count = this.$root.$data.cart.items.length - 1;

      this.removeItem(count).then(function () {
        if (count > 0) {
          _this3.emptyCart();
        } else {
          _this3.state.stop('emptying-cart');
        }
      });
    },
    getProductImage: function getProductImage(product) {
      return 'background-image: url(\'' + product.image_url + '\')';
    }
  }
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_api_order__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_api_cart__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_api_cartItem__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_api_attachment__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_api_deliveryAddress__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_api_me__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__js_helpers_state__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__js_helpers_errors__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__js_mixins_hasPrices__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__js_mixins_hasPictures__ = __webpack_require__(58);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_8__js_mixins_hasPrices__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__js_mixins_hasPictures__["a" /* default */]],

  data: function data() {
    return {
      state: new __WEBPACK_IMPORTED_MODULE_6__js_helpers_state__["a" /* default */](),
      errors: new __WEBPACK_IMPORTED_MODULE_7__js_helpers_errors__["a" /* default */](),
      user: null,
      title: '',
      notes: '',
      addresses: [],
      deliveryAddress: -1,
      data: {
        client: {
          name: '',
          email: '',
          phone: ''
        }
      }
    };
  },
  mounted: function mounted() {
    this.state.start('working');
    __WEBPACK_IMPORTED_MODULE_1__js_api_cart__["a" /* default */].get().then(this.onCartSuccess);
    __WEBPACK_IMPORTED_MODULE_4__js_api_deliveryAddress__["a" /* default */].index().then(this.onDeliveryAddressesSuccess);
    __WEBPACK_IMPORTED_MODULE_5__js_api_me__["a" /* default */].show().then(this.onMeSuccess);
  },


  methods: {
    onCartSuccess: function onCartSuccess(cart) {
      __WEBPACK_IMPORTED_MODULE_1__js_api_cart__["a" /* default */].show(cart.id).then(this.onFetchSuccess);
    },
    onDeliveryAddressesSuccess: function onDeliveryAddressesSuccess(response) {
      this.addresses = response.data.data;
    },
    onMeSuccess: function onMeSuccess(response) {
      this.user = response.data.data;
    },
    onFetchSuccess: function onFetchSuccess(response) {
      this.$root.$data.cart = response.data.data;
      this.state.stop('working');
    },
    pickFile: function pickFile(id, type) {
      document.getElementById('file_' + type + '_' + id).click();
    },
    onFileChange: function onFileChange(e, id, type) {
      var _this = this;

      var element = document.getElementById('file_' + type + '_' + id);

      if (element.files[0] === undefined) {
        return;
      }

      var data = new FormData();

      data.append('attachable_id', id);
      data.append('attachable_type', type);
      data.append('attachment', element.files[0]);

      this.state.start('working');

      __WEBPACK_IMPORTED_MODULE_3__js_api_attachment__["a" /* default */].store(data).then(function (response) {
        if (type === 'cart') {
          _this.$root.$data.cart.attachments.push(response.data.data);
        } else {
          var index = _.findIndex(_this.$root.$data.cart.items, function (o) {
            return o.id === id;
          });
          _this.$root.$data.cart.items[index].attachments.push(response.data.data);
        }
      }).then(function () {
        _this.state.stop('working');
      });
    },
    deleteAttachment: function deleteAttachment(itemIndex, id, type) {
      var _this2 = this;

      this.state.start('working');

      __WEBPACK_IMPORTED_MODULE_3__js_api_attachment__["a" /* default */].remove(id).then(function (response) {
        if (type === 'cart') {
          var attachments = _this2.$root.$data.cart.attachments;
          var index = _.findIndex(attachments, function (o) {
            return o.id === id;
          });
          attachments.splice(index, 1);
        } else {
          var _attachments = _this2.$root.$data.cart.items[itemIndex].attachments;
          var _index = _.findIndex(_attachments, function (o) {
            return o.id === id;
          });
          _attachments.splice(_index, 1);
        }
      }).then(function () {
        _this2.state.stop('working');
      });
    },
    placeOrder: function placeOrder() {
      var _this3 = this;

      var orderData = this.data;
      orderData.delivery_address = this.selectedAddress;

      var data = {
        cart_id: this.$root.$data.cart.id,
        title: this.title,
        notes: this.notes,
        data: orderData
      };

      this.errors.clearErrors();
      this.state.start('ordering');

      __WEBPACK_IMPORTED_MODULE_0__js_api_order__["a" /* default */].store(data).then(function (response) {
        var order = response.data;
        _this3.$router.push({ name: 'order-complete', params: { orderId: order.id } });
        _this3.state.stop('ordering');
      }).catch(function (error) {
        _this3.errors.setErrors(error.response.data.errors);
        _this3.state.stop('ordering');
      });
    },
    goBack: function goBack() {
      this.$router.go(-1);
    }
  },

  computed: {
    selectedAddress: function selectedAddress() {
      if (this.deliveryAddress === -1) {
        return this.user.store.post_address;
      }

      return this.addresses[this.deliveryAddress].address;
    }
  }
});

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_api_order__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_mixins_hasPrices__ = __webpack_require__(34);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__js_mixins_hasPrices__["a" /* default */]],

  data: function data() {
    return {
      orders: null
    };
  },
  mounted: function mounted() {
    // this.state.start('loading');
    __WEBPACK_IMPORTED_MODULE_0__js_api_order__["a" /* default */].index().then(this.onFetchSuccess);
  },


  methods: {
    onFetchSuccess: function onFetchSuccess(response) {
      this.orders = response.data.data;
      // this.state.stop('loading');
    },
    viewOrder: function viewOrder(id) {
      this.$router.push({ name: 'view-order', params: { orderId: id } });
    },
    goToShop: function goToShop() {
      this.$router.push({ name: 'shop' });
    },
    toLocaleDate: function toLocaleDate(date) {
      return moment(date).format('Do MMMM YYYY \\k\\l. HH:mm');
    }
  }
});

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('cart');
    this.$root.$data.cart = null;
  },


  methods: {
    viewOrder: function viewOrder() {
      this.$router.push({ name: 'view-order', params: { orderId: this.$route.params.orderId } });
    }
  }
});

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_api_product__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_api_productPrice__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_api_cartItem__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_api_cart__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_mixins_hasPrices__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_mixins_hasPictures__ = __webpack_require__(58);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_4__js_mixins_hasPrices__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__js_mixins_hasPictures__["a" /* default */]],

  data: function data() {
    return {
      product: null,
      quantity: 0,
      selectedPicture: 0,
      price: null,
      unitPrice: null,
      parametersLoaded: false
    };
  },
  mounted: function mounted() {
    // this.state.start('loading');
    this.fetch(this.$route.params.productId);
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // Reset
    this.product = null;
    this.quantity = 1;
    this.price = null;
    this.unitPrice = null;
    this.parametersLoaded = false;

    this.fetch(to.params.productId);

    next();
  },


  methods: {
    fetch: function fetch(id) {
      __WEBPACK_IMPORTED_MODULE_0__js_api_product__["a" /* default */].show(id).then(this.onFetchSuccess);
    },
    onFetchSuccess: function onFetchSuccess(response) {
      var product = response.data.data;

      product.accessories = _.map(product.accessories, function (o) {
        o.quantity = 1;
        return o;
      });

      product.related = _.map(product.related, function (o) {
        o.quantity = 1;
        return o;
      });

      this.product = product;
      this.fetchPrice();
      // this.state.stop('loading');
    },
    onPriceSuccess: function onPriceSuccess(response) {
      this.price = response.data.data.price;
      this.unitPrice = response.data.data.unit_price;
    },
    onParametersLoaded: function onParametersLoaded() {
      this.parametersLoaded = true;
      this.quantity = 1;
    },
    onParametersChanged: function onParametersChanged() {
      this.fetchPrice();
    },
    fetchPrice: function fetchPrice() {
      if (this.quantity > 0) {
        if (this.source !== undefined) {
          this.source.cancel();
        }

        var CancelToken = axios.CancelToken;
        this.source = CancelToken.source();

        var data = {
          product_id: this.$route.params.productId,
          quantity: this.quantity,
          parameters: this.$refs.parameters.parameters
        };

        __WEBPACK_IMPORTED_MODULE_1__js_api_productPrice__["a" /* default */].create(data, this.source.token).then(this.onPriceSuccess).catch(function (error) {});
      } else {
        this.price = null;
        this.unit_price = null;
      }
    },
    viewProduct: function viewProduct(id) {
      this.$router.push({ name: 'view-product', params: { productId: id } });
    },
    buy: function buy() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_3__js_api_cart__["a" /* default */].get().then(function (cart) {
        var data = {
          cart_id: cart.id,
          product_id: _this.$route.params.productId,
          quantity: _this.quantity,
          parameters: _this.$refs.parameters.parameters
        };

        __WEBPACK_IMPORTED_MODULE_2__js_api_cartItem__["a" /* default */].store(data).then(function () {
          _this.$router.push({ name: 'cart' });
        });
      });
    },
    buyAccesory: function buyAccesory(product) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_3__js_api_cart__["a" /* default */].get().then(function (cart) {
        var data = {
          cart_id: cart.id,
          product_id: product.id,
          quantity: product.quantity,
          parameters: []
        };

        __WEBPACK_IMPORTED_MODULE_2__js_api_cartItem__["a" /* default */].store(data).then(function () {
          _this2.$router.push({ name: 'cart' });
        });
      });
    }
  },

  computed: {
    mainPicture: function mainPicture() {
      return this.product.pictures[0];
    },
    extraPictures: function extraPictures() {
      return this.product.pictures.slice(1);
    }
  },

  watch: {
    quantity: function quantity(value) {
      this.fetchPrice();
    }
  }
});

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_api_category__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_mixins_hasPrices__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_mixins_hasPictures__ = __webpack_require__(58);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__js_mixins_hasPrices__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__js_mixins_hasPictures__["a" /* default */]],

  data: function data() {
    return {
      category: null
    };
  },
  mounted: function mounted() {
    this.fetch(this.$route.params.categoryId);
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    // Reset
    this.category = null;

    this.fetch(to.params.categoryId);

    next();
  },


  methods: {
    fetch: function fetch(slug) {
      __WEBPACK_IMPORTED_MODULE_0__js_api_category__["a" /* default */].show(slug).then(this.onFetchSuccess);
    },
    onFetchSuccess: function onFetchSuccess(response) {
      this.category = response.data.data;
      // this.state.stop('loading');
    },
    viewProduct: function viewProduct(id) {
      this.$router.push({ name: 'view-product', params: { productId: id } });
    },
    getProductImage: function getProductImage(product) {
      return 'background-image: url(\'' + product.image_url + '\')';
    }
  }
});

/***/ }),

/***/ 346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_api_order__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_api_attachment__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_api_notifications__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__js_helpers_state__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__js_helpers_errors__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__js_mixins_hasPrices__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__js_mixins_hasPictures__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__js_mixins_hasDialogs__ = __webpack_require__(332);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_5__js_mixins_hasPrices__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__js_mixins_hasPictures__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__js_mixins_hasDialogs__["a" /* default */]],

  data: function data() {
    return {
      state: new __WEBPACK_IMPORTED_MODULE_3__js_helpers_state__["a" /* default */](),
      errors: new __WEBPACK_IMPORTED_MODULE_4__js_helpers_errors__["a" /* default */](),
      order: null,
      prompt: {
        email: ''
      }
    };
  },
  mounted: function mounted() {
    // this.state.start('loading');
    __WEBPACK_IMPORTED_MODULE_0__js_api_order__["a" /* default */].show(this.$route.params.orderId).then(this.onFetchSuccess);
  },


  methods: {
    onFetchSuccess: function onFetchSuccess(response) {
      this.order = response.data;
      this.prompt.email = this.order.data.client.email;
      // this.state.stop('loading');
    },
    downloadOrder: function downloadOrder() {
      var url = "https://staples-api.myorder.no/v1/" + 'order-pdfs/' + this.order.uuid;
      window.open(url);
    },
    sendNotification: function sendNotification() {
      var _this = this;

      this.state.start('sending');

      __WEBPACK_IMPORTED_MODULE_2__js_api_notifications__["a" /* default */].sendOrderClientSummary(this.order.id, this.prompt.email).then(function (response) {
        _this.state.stop('sending');
        _this.closeDialog('sendSummaryDialog');
        snack('Ordrebekreftelse sendt!');
      }).catch(function (error) {
        _this.state.stop('sending');
        if (error.response !== undefined) {
          _this.errors.setErrors(error.response.data.errors);
        }
      });
    },
    pickFile: function pickFile(id, type) {
      document.getElementById('file_' + type + '_' + id).click();
    },
    onFileChange: function onFileChange(e, id, type) {
      var _this2 = this;

      var element = document.getElementById('file_' + type + '_' + id);

      if (element.files[0] === undefined) {
        return;
      }

      var data = new FormData();

      data.append('attachable_id', id);
      data.append('attachable_type', type);
      data.append('attachment', element.files[0]);

      this.state.start('working');

      __WEBPACK_IMPORTED_MODULE_1__js_api_attachment__["a" /* default */].store(data).then(function (response) {
        if (type === 'order') {
          _this2.order.attachments.push(response.data.data);
        } else {
          var index = _.findIndex(_this2.order.lines, function (o) {
            return o.id === id;
          });
          _this2.order.lines[index].attachments.push(response.data.data);
        }
      }).then(function () {
        _this2.state.stop('working');
      });
    },
    deleteAttachment: function deleteAttachment(itemIndex, id, type) {
      var _this3 = this;

      this.state.start('working');

      __WEBPACK_IMPORTED_MODULE_1__js_api_attachment__["a" /* default */].remove(id).then(function (response) {
        if (type === 'order') {
          var attachments = _this3.order.attachments;
          var index = _.findIndex(attachments, function (o) {
            return o.id === id;
          });
          attachments.splice(index, 1);
        } else {
          var _attachments = _this3.order.lines[itemIndex].attachments;
          var _index = _.findIndex(_attachments, function (o) {
            return o.id === id;
          });
          _attachments.splice(_index, 1);
        }
      }).then(function () {
        _this3.state.stop('working');
      });
    },
    toLocaleDate: function toLocaleDate(date) {
      return moment(date).format('Do MMMM YYYY \\k\\l. HH:mm');
    }
  }
});

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_api_cart__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_api_me__ = __webpack_require__(90);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cart: null,
      user: null
    };
  },
  mounted: function mounted() {
    // this.state.start('loading');
    __WEBPACK_IMPORTED_MODULE_0__js_api_cart__["a" /* default */].get().then(this.onCartSuccess);
    __WEBPACK_IMPORTED_MODULE_1__js_api_me__["a" /* default */].show().then(this.onMeSuccess);
  },


  methods: {
    toggleSidenav: function toggleSidenav() {
      this.$refs.sidenav.toggle();
    },
    onCartSuccess: function onCartSuccess(cart) {
      __WEBPACK_IMPORTED_MODULE_0__js_api_cart__["a" /* default */].show(cart.id).then(this.onFetchSuccess);
    },
    onMeSuccess: function onMeSuccess(response) {
      this.user = response.data.data;
    },
    onFetchSuccess: function onFetchSuccess(response) {
      this.cart = response.data.data;
      // this.state.stop('loading');
    },
    viewCart: function viewCart() {
      this.$router.push({ name: 'cart' });
    }
  }
});

/***/ }),

/***/ 348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_api_cart__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_helpers_state__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_mixins_hasPrices__ = __webpack_require__(34);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__js_mixins_hasPrices__["a" /* default */]],

  data: function data() {
    return {
      state: new __WEBPACK_IMPORTED_MODULE_1__js_helpers_state__["a" /* default */](),
      cart: null
    };
  },
  mounted: function mounted() {
    this.state.start('loading');
    __WEBPACK_IMPORTED_MODULE_0__js_api_cart__["a" /* default */].get().then(this.onCartSuccess);
  },


  methods: {
    onCartSuccess: function onCartSuccess(cart) {
      __WEBPACK_IMPORTED_MODULE_0__js_api_cart__["a" /* default */].show(cart.id).then(this.onFetchSuccess);
    },
    onFetchSuccess: function onFetchSuccess(response) {
      this.$root.$data.cart = response.data.data;
      this.state.stop('loading');
    }
  }
});

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__js_api_cart__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__js_helpers_state__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__js_mixins_hasPrices__ = __webpack_require__(34);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__js_mixins_hasPrices__["a" /* default */]],

  data: function data() {
    return {
      state: new __WEBPACK_IMPORTED_MODULE_1__js_helpers_state__["a" /* default */](),
      cart: null
    };
  },
  mounted: function mounted() {
    this.state.start('loading');
    __WEBPACK_IMPORTED_MODULE_0__js_api_cart__["a" /* default */].get().then(this.onCartSuccess);
  },


  methods: {
    onCartSuccess: function onCartSuccess(cart) {
      __WEBPACK_IMPORTED_MODULE_0__js_api_cart__["a" /* default */].show(cart.id).then(this.onFetchSuccess);
    },
    onFetchSuccess: function onFetchSuccess(response) {
      this.$root.$data.cart = response.data.data;
      this.state.stop('loading');
    }
  }
});

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var State = function () {
  function State() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, State);

    this.processes = [];
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(State, [{
    key: "isNot",
    value: function isNot(key) {
      return !this.is(key);
    }
  }, {
    key: "is",
    value: function is(key) {
      if (key === undefined) {
        return this.processes.length > 0;
      }

      return _.includes(this.processes, key);
    }
  }, {
    key: "start",
    value: function start(key) {
      if (!this.is(key)) {
        this.processes.push(key);
      }
    }
  }, {
    key: "stop",
    value: function stop(key) {
      if (key === undefined) {
        this.processes.splice(0, this.processes.length);
      } else {
        var index = this.processes.indexOf(key);
        this.processes.splice(index, 1);
      }
    }
  }]);

  return State;
}();

/* harmony default export */ __webpack_exports__["a"] = (State);

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);



var baseUri = 'carts';

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get() {
    var cart = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.getJSON('cart');

    if (cart === undefined) {
      return api.get('latest-cart').then(function (response) {
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('cart', response.data.data);
        return response.data.data;
      });
    }

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      resolve(cart);
    });
  },
  refresh: function refresh() {
    var cart = __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.getJSON('cart');

    return api.get(baseUri + '/' + cart.id).then(function (response) {
      __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('cart', response.data.data);
      return response.data.data;
    });
  },
  show: function show(id) {
    return api.get(baseUri + '/' + id);
  },
  create: function create() {
    return api.post('' + baseUri);
  }
});

/***/ }),

/***/ 58:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getPicture: function getPicture(product) {
      if (product.pictures.length === 0) {
        return null;
      }

      var picture = product.pictures[0];

      return picture.href;
    },
    getThumbnail: function getThumbnail(product) {
      if (product.pictures.length === 0) {
        return null;
      }

      var picture = product.pictures[0];
      var thumbnail = _.find(picture.thumbnails, function (o) {
        return o.format === '120x120';
      });

      if (thumbnail === undefined) {
        return null;
      }

      return thumbnail.href;
    }
  }
});

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 590:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 591:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 592:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 593:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 594:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 595:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 596:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 597:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 598:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 599:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 600:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 601:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 604:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 605:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 606:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 607:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 612:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 184,
	"./af.js": 184,
	"./ar": 191,
	"./ar-dz": 185,
	"./ar-dz.js": 185,
	"./ar-kw": 186,
	"./ar-kw.js": 186,
	"./ar-ly": 187,
	"./ar-ly.js": 187,
	"./ar-ma": 188,
	"./ar-ma.js": 188,
	"./ar-sa": 189,
	"./ar-sa.js": 189,
	"./ar-tn": 190,
	"./ar-tn.js": 190,
	"./ar.js": 191,
	"./az": 192,
	"./az.js": 192,
	"./be": 193,
	"./be.js": 193,
	"./bg": 194,
	"./bg.js": 194,
	"./bm": 195,
	"./bm.js": 195,
	"./bn": 196,
	"./bn.js": 196,
	"./bo": 197,
	"./bo.js": 197,
	"./br": 198,
	"./br.js": 198,
	"./bs": 199,
	"./bs.js": 199,
	"./ca": 200,
	"./ca.js": 200,
	"./cs": 201,
	"./cs.js": 201,
	"./cv": 202,
	"./cv.js": 202,
	"./cy": 203,
	"./cy.js": 203,
	"./da": 204,
	"./da.js": 204,
	"./de": 207,
	"./de-at": 205,
	"./de-at.js": 205,
	"./de-ch": 206,
	"./de-ch.js": 206,
	"./de.js": 207,
	"./dv": 208,
	"./dv.js": 208,
	"./el": 209,
	"./el.js": 209,
	"./en-au": 210,
	"./en-au.js": 210,
	"./en-ca": 211,
	"./en-ca.js": 211,
	"./en-gb": 212,
	"./en-gb.js": 212,
	"./en-ie": 213,
	"./en-ie.js": 213,
	"./en-nz": 214,
	"./en-nz.js": 214,
	"./eo": 215,
	"./eo.js": 215,
	"./es": 218,
	"./es-do": 216,
	"./es-do.js": 216,
	"./es-us": 217,
	"./es-us.js": 217,
	"./es.js": 218,
	"./et": 219,
	"./et.js": 219,
	"./eu": 220,
	"./eu.js": 220,
	"./fa": 221,
	"./fa.js": 221,
	"./fi": 222,
	"./fi.js": 222,
	"./fo": 223,
	"./fo.js": 223,
	"./fr": 226,
	"./fr-ca": 224,
	"./fr-ca.js": 224,
	"./fr-ch": 225,
	"./fr-ch.js": 225,
	"./fr.js": 226,
	"./fy": 227,
	"./fy.js": 227,
	"./gd": 228,
	"./gd.js": 228,
	"./gl": 229,
	"./gl.js": 229,
	"./gom-latn": 230,
	"./gom-latn.js": 230,
	"./gu": 231,
	"./gu.js": 231,
	"./he": 232,
	"./he.js": 232,
	"./hi": 233,
	"./hi.js": 233,
	"./hr": 234,
	"./hr.js": 234,
	"./hu": 235,
	"./hu.js": 235,
	"./hy-am": 236,
	"./hy-am.js": 236,
	"./id": 237,
	"./id.js": 237,
	"./is": 238,
	"./is.js": 238,
	"./it": 239,
	"./it.js": 239,
	"./ja": 240,
	"./ja.js": 240,
	"./jv": 241,
	"./jv.js": 241,
	"./ka": 242,
	"./ka.js": 242,
	"./kk": 243,
	"./kk.js": 243,
	"./km": 244,
	"./km.js": 244,
	"./kn": 245,
	"./kn.js": 245,
	"./ko": 246,
	"./ko.js": 246,
	"./ky": 247,
	"./ky.js": 247,
	"./lb": 248,
	"./lb.js": 248,
	"./lo": 249,
	"./lo.js": 249,
	"./lt": 250,
	"./lt.js": 250,
	"./lv": 251,
	"./lv.js": 251,
	"./me": 252,
	"./me.js": 252,
	"./mi": 253,
	"./mi.js": 253,
	"./mk": 254,
	"./mk.js": 254,
	"./ml": 255,
	"./ml.js": 255,
	"./mr": 256,
	"./mr.js": 256,
	"./ms": 258,
	"./ms-my": 257,
	"./ms-my.js": 257,
	"./ms.js": 258,
	"./my": 259,
	"./my.js": 259,
	"./nb": 126,
	"./nb.js": 126,
	"./ne": 260,
	"./ne.js": 260,
	"./nl": 262,
	"./nl-be": 261,
	"./nl-be.js": 261,
	"./nl.js": 262,
	"./nn": 263,
	"./nn.js": 263,
	"./pa-in": 264,
	"./pa-in.js": 264,
	"./pl": 265,
	"./pl.js": 265,
	"./pt": 267,
	"./pt-br": 266,
	"./pt-br.js": 266,
	"./pt.js": 267,
	"./ro": 268,
	"./ro.js": 268,
	"./ru": 269,
	"./ru.js": 269,
	"./sd": 270,
	"./sd.js": 270,
	"./se": 271,
	"./se.js": 271,
	"./si": 272,
	"./si.js": 272,
	"./sk": 273,
	"./sk.js": 273,
	"./sl": 274,
	"./sl.js": 274,
	"./sq": 275,
	"./sq.js": 275,
	"./sr": 277,
	"./sr-cyrl": 276,
	"./sr-cyrl.js": 276,
	"./sr.js": 277,
	"./ss": 278,
	"./ss.js": 278,
	"./sv": 279,
	"./sv.js": 279,
	"./sw": 280,
	"./sw.js": 280,
	"./ta": 281,
	"./ta.js": 281,
	"./te": 282,
	"./te.js": 282,
	"./tet": 283,
	"./tet.js": 283,
	"./th": 284,
	"./th.js": 284,
	"./tl-ph": 285,
	"./tl-ph.js": 285,
	"./tlh": 286,
	"./tlh.js": 286,
	"./tr": 287,
	"./tr.js": 287,
	"./tzl": 288,
	"./tzl.js": 288,
	"./tzm": 290,
	"./tzm-latn": 289,
	"./tzm-latn.js": 289,
	"./tzm.js": 290,
	"./uk": 291,
	"./uk.js": 291,
	"./ur": 292,
	"./ur.js": 292,
	"./uz": 294,
	"./uz-latn": 293,
	"./uz-latn.js": 293,
	"./uz.js": 294,
	"./vi": 295,
	"./vi.js": 295,
	"./x-pseudo": 296,
	"./x-pseudo.js": 296,
	"./yo": 297,
	"./yo.js": 297,
	"./zh-cn": 298,
	"./zh-cn.js": 298,
	"./zh-hk": 299,
	"./zh-hk.js": 299,
	"./zh-tw": 300,
	"./zh-tw.js": 300
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 612;

/***/ }),

/***/ 615:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(598)
}
var Component = __webpack_require__(11)(
  /* script */
  null,
  /* template */
  __webpack_require__(639),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 616:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(597)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(638),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 617:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(602)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(643),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(606)
}
var Component = __webpack_require__(11)(
  /* script */
  null,
  /* template */
  __webpack_require__(648),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(594)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(635),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 620:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(603)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(644),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6c7d32b6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 621:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(647),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 622:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(633),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 623:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(593)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(634),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04206286",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(607)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(650),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-fc7ecaa8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(605)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(646),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-76408b97",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 626:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(649),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 627:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(600)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(641),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4d8fd079",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 628:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(595)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(636),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0f587cd2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 629:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(596)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(637),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2346049a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 630:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(604)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(645),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6e932972",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(599)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(640),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b703b48",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 632:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(601)
}
var Component = __webpack_require__(11)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(642),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a7f182f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 633:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb4",
    attrs: {
      "id": "my-profile-view"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clearfix mxn3"
  }, [_c('div', {
    staticClass: "col col-6 px3"
  }, [_c('div', {
    staticClass: "bold fz24 mb3"
  }, [_vm._v("Rediger informasjon")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold ft2 uppercase mb1"
  }, [_vm._v("Personlig informasjon")]), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('name')
    }
  }, [_c('label', [_vm._v("Fullt navn")]), _vm._v(" "), _c('md-input', {
    staticClass: "md-input-block",
    model: {
      value: (_vm.user.name),
      callback: function($$v) {
        _vm.$set(_vm.user, "name", $$v)
      },
      expression: "user.name"
    }
  }), _vm._v(" "), (_vm.errors.hasError('name')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('name')))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('email')
    }
  }, [_c('label', [_vm._v("E-post")]), _vm._v(" "), _c('md-input', {
    staticClass: "md-input-block",
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.user.email),
      callback: function($$v) {
        _vm.$set(_vm.user, "email", $$v)
      },
      expression: "user.email"
    }
  }), _vm._v(" "), (_vm.errors.hasError('email')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('email')))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('phone')
    }
  }, [_c('label', [_vm._v("Mobil")]), _vm._v(" "), _c('md-input', {
    staticClass: "md-input-block",
    model: {
      value: (_vm.user.phone),
      callback: function($$v) {
        _vm.$set(_vm.user, "phone", $$v)
      },
      expression: "user.phone"
    }
  }), _vm._v(" "), (_vm.errors.hasError('phone')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('phone')))]) : _vm._e()], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary btn-wide m0 p1 px3",
    attrs: {
      "disabled": _vm.state.is('saving')
    },
    nativeOn: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("Lagre profil\n        ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col col-6 px3"
  }, [_c('div', {
    staticClass: "bold fz24 mb3"
  }, [_vm._v("Endre passord")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "bold ft2 uppercase mb1"
  }, [_vm._v("Ditt personlige passord")]), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('password')
    }
  }, [_c('label', [_vm._v("Ønsket passord")]), _vm._v(" "), _c('md-input', {
    staticClass: "md-input-block",
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password.new),
      callback: function($$v) {
        _vm.$set(_vm.password, "new", $$v)
      },
      expression: "password.new"
    }
  }), _vm._v(" "), (_vm.errors.hasError('password')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('password')))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('password_confirm')
    }
  }, [_c('label', [_vm._v("Gjennta ønsket passord")]), _vm._v(" "), _c('md-input', {
    staticClass: "md-input-block",
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password.newConfirm),
      callback: function($$v) {
        _vm.$set(_vm.password, "newConfirm", $$v)
      },
      expression: "password.newConfirm"
    }
  }), _vm._v(" "), (_vm.errors.hasError('password_confirm')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('password_confirm')))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('password_old')
    }
  }, [_c('label', [_vm._v("Gammelt passord")]), _vm._v(" "), _c('md-input', {
    staticClass: "md-input-block",
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password.old),
      callback: function($$v) {
        _vm.$set(_vm.password, "old", $$v)
      },
      expression: "password.old"
    }
  }), _vm._v(" "), (_vm.errors.hasError('password_old')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('password_old')))]) : _vm._e()], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary btn-wide m0 p1 px3",
    attrs: {
      "disabled": _vm.state.is('saving-password')
    },
    nativeOn: {
      "click": function($event) {
        _vm.savePassword()
      }
    }
  }, [_vm._v("\n          Endre passord\n        ")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb4"
  }, [_c('div', {
    staticClass: "fz24 light mt2"
  }, [_vm._v("Min profil")]), _vm._v(" "), _c('p', {
    staticClass: "fz16"
  }, [_vm._v("Her kan du redigere din personelige informasjon og endre passordet ditt.\n    ")]), _c('p')])
}]}

/***/ }),

/***/ 634:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$root.$data.cart) ? _c('div', [_c('div', {
    staticClass: "px2 mb3"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary right",
    attrs: {
      "disabled": _vm.$root.$data.cart.items.length == 0
    },
    on: {
      "click": function($event) {
        _vm.goToCheckout()
      }
    }
  }, [_vm._v("Gå til kassen")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised right",
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Tilbake")]), _vm._v(" "), _c('div', {
    staticClass: "fz24 light mt2"
  }, [_vm._v("Handlekurv")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("Du har " + _vm._s(_vm.$root.$data.cart.items.length) + " varer i handlekurven.")])], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "clearfix relative"
  }, [(_vm.state.is('emptying-cart')) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$root.$data.cart.items.length > 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('table', {
    staticClass: "cart-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.$root.$data.cart.items), function(cartItem, index) {
    return _c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "cell-image p2"
    }, [_c('img', {
      staticClass: "rounded pointer",
      attrs: {
        "src": _vm.getThumbnail(cartItem.product),
        "width": "80",
        "height": "80"
      },
      on: {
        "click": function($event) {
          _vm.viewProduct(cartItem.product.id)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz18 mb1 text-blue pointer",
      on: {
        "click": function($event) {
          _vm.viewProduct(cartItem.product.id)
        }
      }
    }, [_vm._v(_vm._s(cartItem.product.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(cartItem.parameters_text))])]), _vm._v(" "), _c('td', [_c('myo-input', {
      staticClass: "center",
      nativeOn: {
        "change": function($event) {
          _vm.updateItem(index)
        }
      },
      model: {
        value: (cartItem.quantity),
        callback: function($$v) {
          _vm.$set(cartItem, "quantity", $$v)
        },
        expression: "cartItem.quantity"
      }
    })], 1), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz24 light text-grey truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(cartItem.unit_price / 100)) + ",-")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz24 light text-blue truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(cartItem.total / 100)) + ",-")])]), _vm._v(" "), _c('td', {
      staticClass: "cell-actions center"
    }, [_c('md-button', {
      staticClass: "md-icon-button",
      nativeOn: {
        "click": function($event) {
          _vm.removeItem(index)
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix flex border-top border-light-grey"
  }, [_c('div', {
    staticClass: "flex-auto p1"
  }, [_c('md-button', {
    nativeOn: {
      "click": function($event) {
        _vm.emptyCart()
      }
    }
  }, [_vm._v("Tøm handlekurven")])], 1), _vm._v(" "), _c('div', {
    staticClass: "p3"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-grey truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.$root.$data.cart.net_total / 100)) + ",-")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("Total eksl. MVA")])]), _vm._v(" "), _c('div', {
    staticClass: "p3"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-grey truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.$root.$data.cart.vat_total / 100)) + ",-")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("MVA")])]), _vm._v(" "), _c('div', {
    staticClass: "p3"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-blue truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.$root.$data.cart.gross_total / 100)) + ",-")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("Total inkl. MVA")])])])]) : _vm._e(), _vm._v(" "), (_vm.$root.$data.cart.items.length == 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('div', {
    staticClass: "p3 center"
  }, [_c('div', {
    staticClass: "fz24 light my3"
  }, [_vm._v("Ingen varer i handlekurven...")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.goToShop()
      }
    }
  }, [_vm._v("Klikk her for å handle")])], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "px2 my3"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary right",
    attrs: {
      "disabled": _vm.$root.$data.cart.items.length == 0
    },
    on: {
      "click": function($event) {
        _vm.goToCheckout()
      }
    }
  }, [_vm._v("Gå til kassen")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised right",
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Tilbake")]), _vm._v(" "), _c('div', {
    staticClass: "fz24 light mt2"
  }, [_vm._v("Handlekurv")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("Du har " + _vm._s(_vm.$root.$data.cart.items.length) + " varer i handlekurven.")])], 1)]) : _c('div', {
    staticClass: "p3 center"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey "
  }), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align"
  }, [_vm._v("Produkt")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Antall")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align"
  }, [_vm._v("Pris pr. stk.")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align",
    attrs: {
      "light": ""
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Handlinger")])])])
}]}

/***/ }),

/***/ 635:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": "top center",
      "md-duration": "4000"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.snackbarMessage))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-accent",
    nativeOn: {
      "click": function($event) {
        _vm.$refs.snackbar.close()
      }
    }
  }, [_vm._v("Lukk")])], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 636:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.category) ? _c('div', [_c('div', {
    staticClass: "fz24 light mt2"
  }, [_vm._v(_vm._s(_vm.category.name))]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("Utforsk varesortimentet nedenfor og plasser bestillingen via handlekurven.")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "clearfix mxn2"
  }, _vm._l((_vm.category.products), function(product) {
    return _c('div', {
      staticClass: "sm-col sm-col-12 md-col-6 lg-col-4 xl-col-3 px2 mb3"
    }, [_c('div', {
      staticClass: "card rounded sh1"
    }, [_c('div', {
      staticClass: "p2 bold pointer",
      on: {
        "click": function($event) {
          _vm.viewProduct(product.id)
        }
      }
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('div', [_c('img', {
      staticClass: "pointer",
      attrs: {
        "src": _vm.getPicture(product),
        "alt": ""
      },
      on: {
        "click": function($event) {
          _vm.viewProduct(product.id)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "p2 product-description"
    }, [_vm._v(_vm._s(product.short_description))]), _vm._v(" "), _c('div', {
      staticClass: "border-bottom border-light-grey"
    }), _vm._v(" "), _c('div', {
      staticClass: "p2"
    }, [_c('md-button', {
      staticClass: "md-raised md-primary right m0",
      nativeOn: {
        "click": function($event) {
          _vm.viewProduct(product.id)
        }
      }
    }, [_vm._v("Kjøp")]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "text-grey fz12"
    }, [_vm._v("Fra")]), _vm._v(" "), _c('div', {
      staticClass: "bold text-grey fz18"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(product.from_price)) + ",-")])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })], 1)])])
  }))])]) : _c('div', {
    staticClass: "p3 center"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 637:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-dialog', {
    ref: "sendSummaryDialog"
  }, [_c('md-dialog-title', [_vm._v("Skriv inn e-post til mottaker")]), _vm._v(" "), _c('md-dialog-content', [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('email')
    }
  }, [_c('label', [_vm._v("E-post")]), _vm._v(" "), _c('md-input', {
    staticClass: "md-input-block",
    model: {
      value: (_vm.prompt.email),
      callback: function($$v) {
        _vm.$set(_vm.prompt, "email", $$v)
      },
      expression: "prompt.email"
    }
  }), _vm._v(" "), (_vm.errors.hasError('email')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('email')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    attrs: {
      "disabled": _vm.state.is('sending')
    },
    on: {
      "click": function($event) {
        _vm.closeDialog('sendSummaryDialog')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    attrs: {
      "disabled": _vm.state.is('sending')
    },
    on: {
      "click": function($event) {
        _vm.sendNotification()
      }
    }
  }, [(_vm.state.is('sending')) ? _c('span', [_vm._v("Sender...")]) : _c('span', [_vm._v("Send")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "fz24 light mt2"
  }, [_vm._v("Ordredetaljer")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb3"
  }, [_vm._v("\n    Her finner du en detaljert overiskt over din ordre. Du kan også håndtere filene for ordren her.")]), _vm._v(" "), (_vm.order) ? _c('div', [_c('div', {
    staticClass: "clearfix mxn2"
  }, [_c('div', {
    staticClass: "col col-4 px2"
  }, [_c('div', {
    staticClass: "card sh1 rounded p3 mb3"
  }, [_c('div', [_c('div', {
    staticClass: "fz24 light mb2"
  }, [_vm._v("Detaljer")]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('div', {
    staticClass: "fz12"
  }, [_vm._v("Navn på bestilling")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('div', {
    staticClass: "fz12"
  }, [_vm._v("Navn/firma (kunde)")]), _vm._v(" "), (_vm.order.data.client.name) ? _c('div', [_vm._v(_vm._s(_vm.order.data.client.name))]) : _c('div', {
    staticClass: "italic"
  }, [_vm._v("Ikke oppgitt...")])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('div', {
    staticClass: "fz12"
  }, [_vm._v("E-post (kunde)")]), _vm._v(" "), (_vm.order.data.client.email) ? _c('div', [_vm._v(_vm._s(_vm.order.data.client.email))]) : _c('div', {
    staticClass: "italic"
  }, [_vm._v("Ikke oppgitt...")])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('div', {
    staticClass: "fz12"
  }, [_vm._v("Plassert")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.toLocaleDate(_vm.order.created_at.time)))])])]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('div', {
    staticClass: "fz24 light mb2"
  }, [_vm._v("Merknader")]), _vm._v(" "), (_vm.order.notes) ? _c('pre', {
    staticClass: "bg-light-grey p3 rounded"
  }, [_vm._v(_vm._s(_vm.order.notes))]) : _c('pre', {
    staticClass: "bg-light-grey p3 rounded"
  }, [_vm._v("Ingen merknader...")])]), _vm._v(" "), _c('div', {
    staticClass: "mt3"
  }, [_c('div', {
    staticClass: "fz24 light mb2"
  }, [_vm._v("Ordrebekreftelse")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary btn-block",
    nativeOn: {
      "click": function($event) {
        _vm.downloadOrder()
      }
    }
  }, [_c('md-icon', {
    staticClass: "mr1"
  }, [_vm._v("file_download")]), _vm._v(" "), _c('span', [_vm._v("Last ned som PDF")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card sh1 rounded p3"
  }, [_c('div', {
    staticClass: "fz24 light mb2"
  }, [_vm._v("Leveringsadresse")]), _vm._v(" "), (_vm.order.data.delivery_address) ? _c('div', [_c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Navn")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.data.delivery_address.name))])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Adresse")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.data.delivery_address.address))])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Postnummer")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.data.delivery_address.zip))])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Poststed")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.order.data.delivery_address.city))])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col col-8 px2"
  }, [_c('div', {
    staticClass: "card sh1 rounded p3 relative"
  }, [(_vm.state.is('working')) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fz24 light"
  }, [_vm._v("Behandle filer")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("\n            Last opp trykklare filer ordren.\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("\n            Om du ønsker å bestille flere varianter av et produkt (f.eks. beachflagg med to forskjellige motiver) kan du legge til flere filer på produktet.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "fz16 bold mb2 mt3"
  }, [_vm._v("Trykkfiler for produkter:")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix relative"
  }, [(_vm.order.lines.length > 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('table', {
    staticClass: "cart-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.order.lines), function(orderLine, index) {
    return _c('tbody', [_c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "p3 border-bottom border-light-grey"
    }, [_c('div', {
      staticClass: "fz24 light mb1"
    }, [_vm._v(_vm._s(orderLine.product.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(orderLine.parameters_text))])]), _vm._v(" "), _c('td', {
      staticClass: "border-bottom border-light-grey center"
    }, [_vm._v("\n                    " + _vm._s(orderLine.quantity) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "border-bottom border-light-grey cell-actions center"
    }, [_c('md-button', {
      staticClass: "md-icon-button text-blue",
      attrs: {
        "type": "file"
      },
      nativeOn: {
        "click": function($event) {
          _vm.pickFile(orderLine.id, 'order_line')
        }
      }
    }, [_c('md-tooltip', [_vm._v("Last opp ny trykkfil")]), _vm._v(" "), _c('md-icon', [_vm._v("file_upload")])], 1), _vm._v(" "), _c('div', {
      staticClass: "hiddenfile"
    }, [_c('input', {
      attrs: {
        "type": "file",
        "id": 'file_order_line_' + orderLine.id
      },
      on: {
        "change": function($event) {
          _vm.onFileChange($event, orderLine.id, 'order_line')
        }
      }
    })])], 1)]), _vm._v(" "), _vm._l((orderLine.attachments), function(attachment, attIndex) {
      return _c('tr', [_c('td', {
        staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey",
        attrs: {
          "colspan": "2"
        }
      }, [_c('div', {
        staticClass: "bold mb1"
      }, [_vm._v("Vedlegg " + _vm._s(attIndex + 1) + ":")]), _vm._v(" "), _c('a', {
        attrs: {
          "href": attachment.artworks[0].href,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(attachment.artworks[0].original_filename))])]), _vm._v(" "), _c('td', {
        staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey"
      }, [_c('md-button', {
        staticClass: "md-icon-button text-grey",
        attrs: {
          "type": "file"
        },
        nativeOn: {
          "click": function($event) {
            _vm.deleteAttachment(index, attachment.id, 'order_line')
          }
        }
      }, [_c('md-tooltip', [_vm._v("Slett vedlegg")]), _vm._v(" "), _c('md-icon', [_vm._v("delete")])], 1)], 1)])
    })], 2)
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fz16 bold mb2 mt3"
  }, [_vm._v("Andre filer:")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix relative"
  }, [(_vm.order.lines.length > 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('table', {
    staticClass: "cart-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.order.attachments), function(attachment, attIndex) {
    return _c('tr', [_c('td', {
      staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey"
    }, [_c('div', {
      staticClass: "bold mb1"
    }, [_vm._v("Vedlegg " + _vm._s(attIndex + 1) + ":")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": attachment.artworks[0].href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(attachment.artworks[0].original_filename))])]), _vm._v(" "), _c('td', {
      staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey center"
    }, [_c('md-button', {
      staticClass: "md-icon-button text-grey",
      attrs: {
        "type": "file"
      },
      nativeOn: {
        "click": function($event) {
          _vm.deleteAttachment(attIndex, attachment.id, 'order')
        }
      }
    }, [_c('md-tooltip', [_vm._v("Slett vedlegg")]), _vm._v(" "), _c('md-icon', [_vm._v("delete")])], 1)], 1)])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey"
  }, [_c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.pickFile(_vm.order.id, 'order')
      }
    }
  }, [_vm._v("\n                      Last opp ny fil\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "hiddenfile"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": 'file_order_' + _vm.order.id
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.order.id, 'order')
      }
    }
  })])], 1), _vm._v(" "), _c('td', {
    staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey center"
  })])], 2)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "card sh1 rounded p3 mt3 pb4"
  }, [_c('div', {
    staticClass: "fz24 light"
  }, [_vm._v("Ordreoversikt")]), _vm._v(" "), _c('table', {
    staticClass: "cart-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.order.lines), function(orderLine, index) {
    return _c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "cell-image p2"
    }, [_c('img', {
      staticClass: "rounded pointer",
      attrs: {
        "src": _vm.getThumbnail(orderLine.product),
        "width": "80",
        "height": "80"
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz18 mb1"
    }, [_vm._v(_vm._s(orderLine.product.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(orderLine.parameters_text))])]), _vm._v(" "), _c('td', {
      staticClass: "center px3"
    }, [_vm._v("\n                " + _vm._s(orderLine.quantity) + "\n              ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz24 light text-grey truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(orderLine.unit_price / 100)) + ",-")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz24 light text-blue truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(orderLine.total / 100)) + ",-")])])])
  }))]), _vm._v(" "), _c('table', {
    staticClass: "full-width"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "border-top border-light-grey",
    staticStyle: {
      "width": "50%"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "border-top border-light-grey"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-grey pt3 truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.order.net_total / 100)) + ",-")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("Total eksl. MVA")])]), _vm._v(" "), _c('td', {
    staticClass: "border-top border-light-grey"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-grey pt3 truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.order.vat_total / 100)) + ",-")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("MVA")])]), _vm._v(" "), _c('td', {
    staticClass: "border-top border-light-grey pt3"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-blue truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.order.gross_total / 100)) + ",-")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("Total inkl. MVA")])])])])])])])])]) : _c('div', {
    staticClass: "p3 center"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey px3 py2 light left-align"
  }, [_vm._v("Produkt")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Antall")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Handlinger")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey px3 py2 light left-align"
  }, [_vm._v("Fil")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Handlinger")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey "
  }), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align"
  }, [_vm._v("Produkt")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Antall")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align"
  }, [_vm._v("Pris pr. stk.")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align",
    attrs: {
      "light": ""
    }
  }, [_vm._v("Total")])])])
}]}

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myo-input"
  }, [(_vm.clearable && _vm.value !== '') ? _c('i', {
    staticClass: "material-icons btn-clear",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.clear()
      }
    }
  }, [_vm._v("cancel")]) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "input",
    attrs: {
      "type": _vm.type,
      "maxlength": _vm.maxlength,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "name": _vm.name,
      "autocomplete": _vm.autocomplete
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        _vm.updateValue($event.target.value)
      }
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 639:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-notification"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 640:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('myo-sidebar', [_c('div', [_c('div', {
    staticClass: "text-grey pt3 pl3 pr3 pb1"
  }, [_vm._v("Innstillinger")]), _vm._v(" "), _c('router-link', {
    staticClass: "myo-list-item",
    attrs: {
      "to": "/app/settings/my-profile"
    }
  }, [_vm._v("Min profil")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "p3"
  }, [_c('router-view')], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 641:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.product) ? _c('div', {
    staticClass: "clearfix mxn2 flex"
  }, [_c('div', {
    staticClass: "col col-4 px2"
  }, [_c('div', {
    staticClass: "card sh1"
  }, [(_vm.product.pictures.length > 0) ? _c('div', {
    staticClass: "p1"
  }, [_c('a', {
    attrs: {
      "href": _vm.mainPicture.href,
      "data-lightbox": "image-1",
      "data-title": _vm.mainPicture.title
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.mainPicture.href
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pictures clearfix mt2 mxn1 flex justify-center"
  }, _vm._l((_vm.extraPictures), function(picture, index) {
    return _c('div', {
      staticClass: "col col-3 px1",
      class: {
        active: index === _vm.selectedPicture
      }
    }, [_c('a', {
      attrs: {
        "href": picture.href,
        "data-lightbox": "image-1",
        "data-title": picture.title
      }
    }, [_c('img', {
      attrs: {
        "src": picture.href
      }
    })])])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p3"
  }, [_c('div', {
    staticClass: "bold fz18 mb2"
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.product.long_description)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col col-8 px2"
  }, [_c('div', {
    staticClass: "bg-white rounded sh1"
  }, [_c('div', {
    staticClass: "clearfix p3"
  }, [_c('div', {
    staticClass: "col col-7 border-right border-light-grey pr3"
  }, [_c('div', {
    staticClass: "bold fz18 mb2"
  }, [_vm._v("Tilpass produktet")]), _vm._v(" "), _c('myo-parameters', {
    ref: "parameters",
    attrs: {
      "type": _vm.product.slug
    },
    on: {
      "loaded": _vm.onParametersLoaded,
      "changed": _vm.onParametersChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-5 pl3"
  }, [_c('div', {
    staticClass: "bold fz18 mb2"
  }, [_vm._v("Pris")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix flex"
  }, [_c('div', {
    staticClass: "col col-6"
  }, [_c('div', {
    staticClass: "fz24 light mb1"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.unitPrice)) + ",-")]), _vm._v(" "), _c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Pr. stk.")])]), _vm._v(" "), _c('div', {
    staticClass: "col col-6 right-align"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-blue"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.price)) + ",-")]), _vm._v(" "), _c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Totalpris inkl. MVA")])])]), _vm._v(" "), _c('div', [_c('myo-input', {
    staticClass: "myo-input-block my2 center",
    attrs: {
      "type": "number",
      "disabled": !_vm.parametersLoaded
    },
    model: {
      value: (_vm.quantity),
      callback: function($$v) {
        _vm.quantity = $$v
      },
      expression: "quantity"
    }
  })], 1), _vm._v(" "), _c('div', [_c('md-button', {
    staticClass: "md-raised md-primary btn-block",
    nativeOn: {
      "click": function($event) {
        _vm.buy()
      }
    }
  }, [_vm._v("Kjøp")])], 1)])])]), _vm._v(" "), (_vm.product.accessories.length > 0) ? _c('div', {
    staticClass: "card sh1 mt3",
    attrs: {
      "id": "accessories"
    }
  }, [_c('div', {
    staticClass: "bold fz18 p3 b border-bottom border-light-grey"
  }, [_vm._v("Tilbehør")]), _vm._v(" "), _c('table', {
    staticClass: "full-width mt1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.product.accessories), function(accessory, index) {
    return _c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "p2 cell-image"
    }, [_c('img', {
      staticClass: "rounded pointer",
      attrs: {
        "src": _vm.getThumbnail(accessory),
        "width": "100",
        "height": "100"
      },
      on: {
        "click": function($event) {
          _vm.viewProduct(accessory.id)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "px2"
    }, [_c('div', {
      staticClass: "fz16 mb1 text-blue pointer",
      on: {
        "click": function($event) {
          _vm.viewProduct(accessory.id)
        }
      }
    }, [_vm._v(_vm._s(accessory.name) + "\n              ")]), _vm._v(" "), _c('div', [_vm._v("\n                " + _vm._s(accessory.short_description) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "px2"
    }, [_c('div', {
      staticClass: "fz24 light mb1 text-blue truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(accessory.from_price)) + ",-")]), _vm._v(" "), _c('small', {
      staticClass: "text-grey"
    }, [_vm._v("Pr. stk.")])]), _vm._v(" "), _c('td', {
      staticClass: "px2 cell-quantity"
    }, [_c('myo-input', {
      staticClass: "myo-input-block my2 center",
      model: {
        value: (accessory.quantity),
        callback: function($$v) {
          _vm.$set(accessory, "quantity", $$v)
        },
        expression: "accessory.quantity"
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "px2 center"
    }, [_c('md-button', {
      staticClass: "md-raised md-primary",
      nativeOn: {
        "click": function($event) {
          _vm.buyAccesory(accessory)
        }
      }
    }, [_vm._v("Kjøp")])], 1)])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.product.related.length > 0) ? _c('div', {
    staticClass: "card sh1 mt3",
    attrs: {
      "id": "related"
    }
  }, [_c('div', {
    staticClass: "bold fz18 p3 b border-bottom border-light-grey"
  }, [_vm._v("Relaterte produkter")]), _vm._v(" "), _c('table', {
    staticClass: "full-width mt1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.product.related), function(related, index) {
    return _c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "p2 cell-image"
    }, [_c('img', {
      staticClass: "rounded pointer",
      attrs: {
        "src": _vm.getThumbnail(related),
        "width": "100",
        "height": "100"
      },
      on: {
        "click": function($event) {
          _vm.viewProduct(related.id)
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "px2"
    }, [_c('div', {
      staticClass: "fz16 mb1 text-blue pointer",
      on: {
        "click": function($event) {
          _vm.viewProduct(related.id)
        }
      }
    }, [_vm._v(_vm._s(related.name) + "\n              ")]), _vm._v(" "), _c('div', [_vm._v("\n                " + _vm._s(related.short_description) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "px2"
    }, [_c('div', {
      staticClass: "fz24 light mb1 text-blue truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(related.from_price)) + ",-")]), _vm._v(" "), _c('small', {
      staticClass: "text-grey"
    }, [_vm._v("Pr. stk.")])]), _vm._v(" "), _c('td', {
      staticClass: "px2 center"
    }, [_c('md-button', {
      staticClass: "md-raised md-primary",
      nativeOn: {
        "click": function($event) {
          _vm.viewProduct(related.id)
        }
      }
    }, [_vm._v("Kjøp")])], 1)])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.product.templates.length > 0) ? _c('div', {
    staticClass: "card sh1 mt3",
    attrs: {
      "id": "templates",
      "md-label": "Maler"
    }
  }, [_c('div', {
    staticClass: "bold fz18 p3 b border-bottom border-light-grey"
  }, [_vm._v("Maler og manualer")]), _vm._v(" "), _c('table', {
    staticClass: "full-width mt1",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.product.templates), function(template, index) {
    return _c('tr', {
      staticClass: "@bg-light-blue"
    }, [_vm._m(3, true), _vm._v(" "), _c('td', {
      staticClass: "border-bottom border-light-grey p2"
    }, [_c('a', {
      staticClass: "fz16 mb1 text-blue pointer",
      attrs: {
        "href": template.href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(template.title))]), _vm._v(" "), _c('div', {
      staticClass: "text-grey mt1"
    }, [_vm._v("\n                " + _vm._s(template.original_filename) + "\n              ")])]), _vm._v(" "), _c('td', {
      staticClass: "border-bottom border-light-grey px2 center"
    }, [_c('a', {
      attrs: {
        "href": template.href,
        "target": "_blank"
      }
    }, [_c('md-button', {
      staticClass: "md-raised md-primary"
    }, [_vm._v("Last ned")])], 1)])])
  }))])]) : _vm._e()])]) : _c('div', {
    staticClass: "p3 center"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-grey px2 py1 left-align",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Produkt")]), _vm._v(" "), _c('th', {
    staticClass: "text-grey px2 py1 left-align"
  }, [_vm._v("Pris")]), _vm._v(" "), _c('th', {
    staticClass: "text-grey px2 py1"
  }, [_vm._v("Antall")]), _vm._v(" "), _c('th', {
    staticClass: "text-grey px2 py1"
  }, [_vm._v("Kjøp")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-grey px2 py1 left-align",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Produkt")]), _vm._v(" "), _c('th', {
    staticClass: "text-grey px2 py1 left-align"
  }, [_vm._v("Pris")]), _vm._v(" "), _c('th', {
    staticClass: "text-grey px2 py1"
  }, [_vm._v("Kjøp")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "text-grey px2 py1 left-align",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Fil")]), _vm._v(" "), _c('th', {
    staticClass: "text-grey px2 py1"
  }, [_vm._v("Last ned")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "border-bottom border-light-grey p2",
    staticStyle: {
      "width": "70px"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/ui/blank-file.svg",
      "width": "50",
      "height": "50"
    }
  })])
}]}

/***/ }),

/***/ 642:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('myo-sidebar', [_c('div', {
    staticClass: "p3 bg-light-blue"
  }, [_c('div', {
    staticClass: "text-grey"
  }, [_vm._v("Handlekurv")]), _vm._v(" "), (_vm.state.is('loading')) ? _c('div', {
    staticClass: " center"
  }, [_c('div', {
    staticClass: "md-spinner md-theme-default md-indeterminate",
    staticStyle: {
      "width": "20px",
      "height": "20px"
    }
  }, [_c('svg', {
    staticClass: "md-spinner-draw",
    attrs: {
      "viewBox": "25 25 50 50"
    }
  }, [_c('circle', {
    staticClass: "md-spinner-path",
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "20",
      "stroke-width": "3.5"
    }
  })])])]) : (_vm.$root.$data.cart) ? _c('div', {
    staticClass: "mt1"
  }, [(_vm.$root.$data.cart.items.length === 0) ? _c('div', [_c('div', {
    staticClass: "fz18 text-blue"
  }, [_vm._v("Handlekurven er tom...")])]) : _c('div', {
    staticClass: "clearfix mt1 bold"
  }, [_c('div', {
    staticClass: "col col-6 fz18 text-blue"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.$root.$data.cart.gross_total / 100)) + ",-")]), _vm._v(" "), _c('div', {
    staticClass: "col col-6 text-dark-grey right-align"
  }, [_vm._v("\n            " + _vm._s(_vm.$root.$data.cart.items.length) + "\n            "), (_vm.$root.$data.cart.items.length > 1) ? _c('span', [_vm._v("varer")]) : _c('span', [_vm._v("vare")])])])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "text-grey pt3 pl3 pr3 pb1"
  }, [_vm._v("Mine sider")]), _vm._v(" "), _c('router-link', {
    staticClass: "myo-list-item",
    attrs: {
      "to": "/app/shop/my-orders"
    }
  }, [_vm._v("Mine ordre")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey pt3 pl3 pr3 pb1"
  }, [_vm._v("Handle")]), _vm._v(" "), _c('router-link', {
    staticClass: "myo-list-item",
    attrs: {
      "to": "/app/shop/category/all"
    }
  }, [_vm._v("Alle produkter")]), _vm._v(" "), _c('router-link', {
    staticClass: "myo-list-item",
    attrs: {
      "to": "/app/shop/category/expo-products"
    }
  }, [_vm._v("Expo-produkter")]), _vm._v(" "), _c('router-link', {
    staticClass: "myo-list-item",
    attrs: {
      "to": "/app/shop/category/digital-print"
    }
  }, [_vm._v("Digitale trykksaker")])], 1), _vm._v(" "), _c('div', {
    staticClass: "px3 py2 italic text-grey"
  }, [_vm._v("Flere produkter kommer snart...")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('div', {
    staticClass: "p3"
  }, [_c('router-view')], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 643:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myo-paramters"
  }, [(_vm.type == 'beachflag') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Form")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "shape",
      "id": "shape"
    },
    model: {
      value: (_vm.parameters.shape),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "shape", $$v)
      },
      expression: "parameters.shape"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "normal"
    }
  }, [_vm._v("Normal")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "drop"
    }
  }, [_vm._v("Dråpe")])], 1)], 1), _vm._v(" "), (_vm.parameters.shape === 'normal') ? _c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Størrelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size",
      "id": "size"
    },
    model: {
      value: (_vm.parameters.size),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "size", $$v)
      },
      expression: "parameters.size"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "small"
    }
  }, [_vm._v("Small (220 cm)")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "medium"
    }
  }, [_vm._v("Medium (265 cm)")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "large"
    }
  }, [_vm._v("Large (365 cm)")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "xl"
    }
  }, [_vm._v("XL (420 cm)")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.parameters.shape === 'drop') ? _c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Størrelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size",
      "id": "size"
    },
    model: {
      value: (_vm.parameters.size),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "size", $$v)
      },
      expression: "parameters.size"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "small"
    }
  }, [_vm._v("Small (181 cm)")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "medium"
    }
  }, [_vm._v("Medium (208 cm)")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "large"
    }
  }, [_vm._v("Large (271 cm)")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "xl"
    }
  }, [_vm._v("XL (372 cm)")])], 1)], 1) : _vm._e()], 1) : (_vm.type == 'banner') ? _c('div', [(_vm.parameters.features) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Materiale")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.features.material),
      callback: function($$v) {
        _vm.$set(_vm.parameters.features, "material", $$v)
      },
      expression: "parameters.features.material"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "pvc"
    }
  }, [_vm._v("PVC")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "textile"
    }
  }, [_vm._v("Tekstil")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Bredde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.width),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "width", $$v)
      },
      expression: "parameters.width"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Høyde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.height),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "height", $$v)
      },
      expression: "parameters.height"
    }
  })], 1), _vm._v(" "), (_vm.parameters.extra) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Maljer/hull")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.extra.holes),
      callback: function($$v) {
        _vm.$set(_vm.parameters.extra, "holes", $$v)
      },
      expression: "parameters.extra.holes"
    }
  }, [_c('md-option', {
    attrs: {
      "value": true
    }
  }, [_vm._v("Ja")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": false
    }
  }, [_vm._v("Nei")])], 1)], 1), _vm._v(" "), (_vm.parameters.extra.holes) ? _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Antall strikker (beregnes automatisk)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number",
      "disabled": true
    },
    model: {
      value: (_vm.parameters.extra.rubber_bands),
      callback: function($$v) {
        _vm.$set(_vm.parameters.extra, "rubber_bands", $$v)
      },
      expression: "parameters.extra.rubber_bands"
    }
  })], 1) : _vm._e()], 1) : _vm._e()], 1) : (_vm.type == 'flex-wall') ? _c('div', [(_vm.parameters.features) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Trykk duk")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.features.sides),
      callback: function($$v) {
        _vm.$set(_vm.parameters.features, "sides", $$v)
      },
      expression: "parameters.features.sides"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "single"
    }
  }, [_vm._v("En-sidig trykk")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "double"
    }
  }, [_vm._v("To-sidig trykk")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.parameters.extra) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Med system")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.extra.system),
      callback: function($$v) {
        _vm.$set(_vm.parameters.extra, "system", $$v)
      },
      expression: "parameters.extra.system"
    }
  }, [_c('md-option', {
    attrs: {
      "value": true
    }
  }, [_vm._v("Ja")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": false
    }
  }, [_vm._v("Nei")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Bredde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.width),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "width", $$v)
      },
      expression: "parameters.width"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Høyde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.height),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "height", $$v)
      },
      expression: "parameters.height"
    }
  })], 1)], 1) : (_vm.type == 'curved-pop-up-wall') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Vegg")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.type),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "type", $$v)
      },
      expression: "parameters.type"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "curved"
    }
  }, [_vm._v("POP-up vegg 225x350 cm")])], 1)], 1)], 1) : (_vm.type == 'expo-tent') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Vegg")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.type),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "type", $$v)
      },
      expression: "parameters.type"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "300x300"
    }
  }, [_vm._v("EXPO-telt 300x300 cm")])], 1)], 1)], 1) : (_vm.type == 'digital-booklet') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Antall sider")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.pages),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "pages", $$v)
      },
      expression: "parameters.pages"
    }
  })], 1)], 1) : (_vm.type == 'alu-frame') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Størrelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size",
      "id": "size"
    },
    model: {
      value: (_vm.parameters.size),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "size", $$v)
      },
      expression: "parameters.size"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "A4"
    }
  }, [_vm._v("A4")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "A3"
    }
  }, [_vm._v("A3")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "A2"
    }
  }, [_vm._v("A2")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "A1"
    }
  }, [_vm._v("A1")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "50x50"
    }
  }, [_vm._v("50x50 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "60x60"
    }
  }, [_vm._v("60x60 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "60x80"
    }
  }, [_vm._v("60x80 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "70x100"
    }
  }, [_vm._v("70x100 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "100x150"
    }
  }, [_vm._v("100x150 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "100x200"
    }
  }, [_vm._v("100x200 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "300x300"
    }
  }, [_vm._v("300x300 cm")])], 1)], 1)], 1) : (_vm.type == 'l-banner') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size",
      "id": "type"
    },
    model: {
      value: (_vm.parameters.type),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "type", $$v)
      },
      expression: "parameters.type"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "single-75x200"
    }
  }, [_vm._v("Enkel 75x200 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "single-90x200"
    }
  }, [_vm._v("Enkel 90x200 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "double-90x200"
    }
  }, [_vm._v("Dobbel 90x200 cm")])], 1)], 1)], 1) : (_vm.type == 'l-banner-graphics') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Størrelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size",
      "id": "type"
    },
    model: {
      value: (_vm.parameters.size),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "size", $$v)
      },
      expression: "parameters.size"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "75x200"
    }
  }, [_vm._v("75x200 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "90x200"
    }
  }, [_vm._v("90x200 cm")])], 1)], 1)], 1) : (_vm.type == 'x-banner') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Størrelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size",
      "id": "type"
    },
    model: {
      value: (_vm.parameters.size),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "size", $$v)
      },
      expression: "parameters.size"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "80x180"
    }
  }, [_vm._v("80x180 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "90x210"
    }
  }, [_vm._v("90x210 cm")])], 1)], 1)], 1) : (_vm.type == 'x-banner-graphics') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Størrelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size",
      "id": "type"
    },
    model: {
      value: (_vm.parameters.size),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "size", $$v)
      },
      expression: "parameters.size"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "80x180"
    }
  }, [_vm._v("80x180 cm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "90x210"
    }
  }, [_vm._v("90x210 cm")])], 1)], 1)], 1) : (_vm.type == 'canvas') ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Størrelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.size),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "size", $$v)
      },
      expression: "parameters.size"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "A4"
    }
  }, [_vm._v("A4")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "A3"
    }
  }, [_vm._v("A3")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "A2"
    }
  }, [_vm._v("A2")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "A1"
    }
  }, [_vm._v("A1")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "50x50"
    }
  }, [_vm._v("50x50")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "60x60"
    }
  }, [_vm._v("60x60")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "70x100"
    }
  }, [_vm._v("70x100")])], 1)], 1)], 1) : (_vm.type == 'alu-plate') ? _c('div', [(_vm.parameters.features) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Tykkelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.features.thickness),
      callback: function($$v) {
        _vm.$set(_vm.parameters.features, "thickness", $$v)
      },
      expression: "parameters.features.thickness"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3 mm")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Bredde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.width),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "width", $$v)
      },
      expression: "parameters.width"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Høyde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.height),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "height", $$v)
      },
      expression: "parameters.height"
    }
  })], 1), _vm._v(" "), (_vm.parameters.extra) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Formskjæring")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.extra.cut_to_shape),
      callback: function($$v) {
        _vm.$set(_vm.parameters.extra, "cut_to_shape", $$v)
      },
      expression: "parameters.extra.cut_to_shape"
    }
  }, [_c('md-option', {
    attrs: {
      "value": true
    }
  }, [_vm._v("Ja")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": false
    }
  }, [_vm._v("Nei")])], 1)], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Hulling")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.extra.holes),
      callback: function($$v) {
        _vm.$set(_vm.parameters.extra, "holes", $$v)
      },
      expression: "parameters.extra.holes"
    }
  }, [_c('md-option', {
    attrs: {
      "value": true
    }
  }, [_vm._v("Ja")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": false
    }
  }, [_vm._v("Nei")])], 1)], 1)], 1) : _vm._e()], 1) : (_vm.type == 'pvc-plate') ? _c('div', [(_vm.parameters.features) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Tykkelse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.features.thickness),
      callback: function($$v) {
        _vm.$set(_vm.parameters.features, "thickness", $$v)
      },
      expression: "parameters.features.thickness"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3 mm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5 mm")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10 mm")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Bredde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.width),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "width", $$v)
      },
      expression: "parameters.width"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "shape"
    }
  }, [_vm._v("Høyde (cm)")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "number"
    },
    model: {
      value: (_vm.parameters.height),
      callback: function($$v) {
        _vm.$set(_vm.parameters, "height", $$v)
      },
      expression: "parameters.height"
    }
  })], 1), _vm._v(" "), (_vm.parameters.extra) ? _c('div', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Hulling")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.extra.holes),
      callback: function($$v) {
        _vm.$set(_vm.parameters.extra, "holes", $$v)
      },
      expression: "parameters.extra.holes"
    }
  }, [_c('md-option', {
    attrs: {
      "value": true
    }
  }, [_vm._v("Ja")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": false
    }
  }, [_vm._v("Nei")])], 1)], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "size"
    }
  }, [_vm._v("Formskjæring")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "size"
    },
    model: {
      value: (_vm.parameters.extra.cut_to_shape),
      callback: function($$v) {
        _vm.$set(_vm.parameters.extra, "cut_to_shape", $$v)
      },
      expression: "parameters.extra.cut_to_shape"
    }
  }, [_c('md-option', {
    attrs: {
      "value": true
    }
  }, [_vm._v("Ja")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": false
    }
  }, [_vm._v("Nei")])], 1)], 1)], 1) : _vm._e()], 1) : _c('div', [_c('div', {
    staticClass: "p2 rounded bg-light-grey"
  }, [_vm._v("\n      Dette produktet trenger ikke å tilpasses.\n    ")])])])
},staticRenderFns: []}

/***/ }),

/***/ 644:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-light-grey full-height flex justify-center items-center border"
  }, [_c('div', {
    attrs: {
      "id": "login-window"
    }
  }, [_c('div', {
    staticClass: "card rounded sh2"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "p3 center"
  }, [_c('div', {
    staticClass: "fz24 mb2"
  }, [_vm._v("Logg inn")]), _vm._v(" "), (_vm.errors.hasError('login')) ? _c('div', {
    staticClass: "error-flash p2 mb2 rounded"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('login')) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.login()
      }
    }
  }, [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('username')
    }
  }, [_c('label', [_vm._v("Brukernavn")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), (_vm.errors.hasError('username')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('username')))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('password')
    },
    attrs: {
      "md-has-password": ""
    }
  }, [_c('label', [_vm._v("Passord")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "type": "password"
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), (_vm.errors.hasError('password')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('password')))]) : _vm._e()], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary btn-block mb3",
    attrs: {
      "disabled": _vm.state.is('authenticating')
    },
    nativeOn: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [(_vm.state.is('authenticating')) ? _c('div', [_vm._v("\n              Logger deg på...\n            ")]) : _c('span', [_vm._v("Logg på")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix mt3"
  }, [_c('div', {
    staticClass: "col col-6 left-align"
  }, [_c('md-checkbox', {
    staticClass: "md-primary m0",
    model: {
      value: (_vm.remember),
      callback: function($$v) {
        _vm.remember = $$v
      },
      expression: "remember"
    }
  }, [_vm._v("Husk meg")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-6 right-align"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Glemt passord?")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "center mt2"
  }, [_c('router-link', {
    staticClass: "text-black",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Administrasjonsportal")])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "created-by"
    }
  }, [_vm._v("Tjenesten er levert av Frode Fjellberg AS")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p3 bg-light-blue center rounded"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "/static/img/ui/copy_print_logo.svg",
      "alt": "MyOrder"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mt2 uppercase fz16 text-dark-blue"
  }, [_vm._v("Bestillingsportal")])])
}]}

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height"
  }, [_c('md-sidenav', {
    ref: "sidenav",
    staticClass: "md-left"
  }, [(_vm.user) ? _c('div', {
    staticClass: "bg-blue px2 pb2 pt4"
  }, [_c('div', {
    staticClass: "fz24"
  }, [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.user.store.name))])]) : _vm._e(), _vm._v(" "), _c('md-list', {
    nativeOn: {
      "click": function($event) {
        _vm.$refs.sidenav.close()
      }
    }
  }, [_c('md-list-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'shop'
      },
      "ex": ""
    }
  }, [_vm._v("Nettbutikk")])], 1), _vm._v(" "), _c('md-list-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'settings'
      }
    }
  }, [_vm._v("Innstillinger")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "border-bottom border-light-grey"
  }), _vm._v(" "), _c('md-list', {
    nativeOn: {
      "click": function($event) {
        _vm.$refs.sidenav.close()
      }
    }
  }, [_c('md-list-item', [_c('router-link', {
    attrs: {
      "to": {
        name: 'logout'
      }
    }
  }, [_vm._v("Logg ut")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "toolbar"
    }
  }, [_c('md-theme', {
    attrs: {
      "md-name": "white"
    }
  }, [_c('md-toolbar', {
    staticClass: "sh2"
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": _vm.toggleSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-auto center"
  }, [_c('img', {
    staticClass: "mr1",
    attrs: {
      "src": "/static/img/ui/copy_print_logo.svg",
      "alt": "MyOrder",
      "width": "110"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mr2"
  }, [_c('md-button', {
    staticClass: "md-icon-button md-has-notification text-grey",
    nativeOn: {
      "click": function($event) {
        _vm.viewCart()
      }
    }
  }, [_c('md-tooltip', [_vm._v("Handlekurv")]), _vm._v(" "), (_vm.$root.$data.cart) ? _c('md-notification', {
    staticClass: "md-blue"
  }, [_vm._v(_vm._s(_vm.$root.$data.cart.items.length))]) : _vm._e(), _vm._v(" "), _c('md-icon', [_vm._v("shopping_cart")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 646:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "fz24 light mt2"
  }, [_vm._v("Mine ordre")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb3"
  }, [_vm._v("Her finner du en ovesikt over dine ordre. Klikk på en av ordrene for å f.eks. laste opp nye filer.")]), _vm._v(" "), (_vm.orders) ? _c('div', [(_vm.orders.length > 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('table', {
    staticClass: "order-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.orders), function(order, index) {
    return _c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "px3 py2"
    }, [_c('div', {
      staticClass: "fz18 mb1 pointer",
      on: {
        "click": function($event) {
          _vm.viewOrder(order.id)
        }
      }
    }, [_vm._v(_vm._s(order.title))]), _vm._v(" "), (order.lines_count > 1) ? _c('div', [_vm._v(_vm._s(order.lines_count) + " produkter")]) : _c('div', [_vm._v(_vm._s(order.lines_count) + " produkt")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "text-grey truncate"
    }, [_vm._v(_vm._s(_vm.toLocaleDate(order.created_at.date)))])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz24 light text-blue truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(order.gross_total / 100)) + ",-")])]), _vm._v(" "), _c('td', {
      staticClass: "cell-actions center"
    }, [_c('md-button', {
      staticClass: "md-icon-button text-grey",
      nativeOn: {
        "click": function($event) {
          _vm.viewOrder(order.id)
        }
      }
    }, [_c('md-tooltip', [_vm._v("Se detaljer")]), _vm._v(" "), _c('md-icon', [_vm._v("remove_red_eye")])], 1)], 1)])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.orders.length == 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('div', {
    staticClass: "p3 center"
  }, [_c('div', {
    staticClass: "fz24 light my3"
  }, [_vm._v("Du har ikke plassert noen ordre ennå...")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.goToShop()
      }
    }
  }, [_vm._v("Klikk her for å handle")])], 1)]) : _vm._e()]) : _c('div', {
    staticClass: "p3 center"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey py2 px3 light left-align"
  }, [_vm._v("Bestilling")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align"
  }, [_vm._v("Plassert")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align",
    attrs: {
      "light": ""
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Handlinger")])])])
}]}

/***/ }),

/***/ 647:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),

/***/ 648:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "myo-sidebar"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 649:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center"
  }, [_c('div', {
    staticClass: "bg-white rounded center p4 inline-block mt2"
  }, [_c('div', {
    staticClass: "fz32 light mt2"
  }, [_vm._v("Takk for besillingen!")]), _vm._v(" "), _c('div', {
    staticClass: "fz16 pt3 pb2"
  }, [_vm._v("\n      Din bestilling har blitt mottatt og vil bli behandlet så raskt som mulig.\n    ")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary px3 py1",
    nativeOn: {
      "click": function($event) {
        _vm.viewOrder()
      }
    }
  }, [_vm._v("Se din ordre her")])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$root.$data.cart) ? _c('div', [_c('div', {
    staticClass: "px2 mb3"
  }, [_c('md-button', {
    staticClass: "md-raised right",
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v("Tilbake")]), _vm._v(" "), _c('div', {
    staticClass: "fz24 light mt2"
  }, [_vm._v("Fullfør bestilling")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("Last opp filer og se over detaljene nedenfor før du fullfører bestillingen.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "px2 mb3"
  }, [_c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step-number"
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('div', {
    staticClass: "fz24 light"
  }, [_vm._v("Last opp filer")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("\n            Last opp trykklare filer for produktene du skal bestille.\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb2"
  }, [_vm._v("\n            Om du ønsker å bestille flere varianter av et produkt (f.eks. beachflagg med to forskjellige motiver) kan du legge til flere filer på produktet.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "fz16 bold mb2 mt3"
  }, [_vm._v("Trykkfiler for produkter:")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix relative"
  }, [(_vm.state.is('working')) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$root.$data.cart.items.length > 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('table', {
    staticClass: "cart-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.$root.$data.cart.items), function(cartItem, index) {
    return _c('tbody', [_c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "p3 border-bottom border-light-grey"
    }, [_c('div', {
      staticClass: "fz24 light mb1"
    }, [_vm._v(_vm._s(cartItem.product.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(cartItem.parameters_text))])]), _vm._v(" "), _c('td', {
      staticClass: "border-bottom border-light-grey center"
    }, [_vm._v("\n                    " + _vm._s(cartItem.quantity) + "\n                  ")]), _vm._v(" "), _c('td', {
      staticClass: "border-bottom border-light-grey cell-actions center"
    }, [_c('md-button', {
      staticClass: "md-icon-button text-blue",
      attrs: {
        "type": "file"
      },
      nativeOn: {
        "click": function($event) {
          _vm.pickFile(cartItem.id, 'cart_item')
        }
      }
    }, [_c('md-tooltip', [_vm._v("Last opp ny trykkfil")]), _vm._v(" "), _c('md-icon', [_vm._v("file_upload")])], 1), _vm._v(" "), _c('div', {
      staticClass: "hiddenfile"
    }, [_c('input', {
      attrs: {
        "type": "file",
        "id": 'file_cart_item_' + cartItem.id
      },
      on: {
        "change": function($event) {
          _vm.onFileChange($event, cartItem.id, 'cart_item')
        }
      }
    })])], 1)]), _vm._v(" "), _vm._l((cartItem.attachments), function(attachment, attIndex) {
      return _c('tr', [_c('td', {
        staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey",
        attrs: {
          "colspan": "2"
        }
      }, [_c('div', {
        staticClass: "bold mb1"
      }, [_vm._v("Vedlegg " + _vm._s(attIndex + 1) + ":")]), _vm._v(" "), _c('a', {
        attrs: {
          "href": attachment.artworks[0].href,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(attachment.artworks[0].original_filename))])]), _vm._v(" "), _c('td', {
        staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey"
      }, [_c('md-button', {
        staticClass: "md-icon-button text-grey",
        attrs: {
          "type": "file"
        },
        nativeOn: {
          "click": function($event) {
            _vm.deleteAttachment(index, attachment.id, 'cart_items')
          }
        }
      }, [_c('md-tooltip', [_vm._v("Slett vedlegg")]), _vm._v(" "), _c('md-icon', [_vm._v("delete")])], 1)], 1)])
    })], 2)
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fz16 bold mb2 mt3"
  }, [_vm._v("Andre filer:")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix relative"
  }, [(_vm.state.is('working')) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.$root.$data.cart.items.length > 0) ? _c('div', {
    staticClass: "card rounded sh1"
  }, [_c('table', {
    staticClass: "cart-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.$root.$data.cart.attachments), function(attachment, attIndex) {
    return _c('tr', [_c('td', {
      staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey"
    }, [_c('div', {
      staticClass: "bold mb1"
    }, [_vm._v("Vedlegg " + _vm._s(attIndex + 1) + ":")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": attachment.artworks[0].href,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(attachment.artworks[0].original_filename))])]), _vm._v(" "), _c('td', {
      staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey center"
    }, [_c('md-button', {
      staticClass: "md-icon-button text-grey",
      attrs: {
        "type": "file"
      },
      nativeOn: {
        "click": function($event) {
          _vm.deleteAttachment(attIndex, attachment.id, 'cart')
        }
      }
    }, [_c('md-tooltip', [_vm._v("Slett vedlegg")]), _vm._v(" "), _c('md-icon', [_vm._v("delete")])], 1)], 1)])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey"
  }, [_c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        _vm.pickFile(_vm.$root.$data.cart.id, 'cart')
      }
    }
  }, [_vm._v("\n                      Last opp ny fil\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "hiddenfile"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": 'file_cart_' + _vm.$root.$data.cart.id
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event, _vm.$root.$data.cart.id, 'cart')
      }
    }
  })])], 1), _vm._v(" "), _c('td', {
    staticClass: "px3 py2 bg-light-grey border-bottom border-middle-grey center"
  })])], 2)])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step-number"
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('div', {
    staticClass: "fz24 light"
  }, [_vm._v("Merknader til bestilling")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb3"
  }, [_vm._v("\n            Fyll inn eventuelle merknader du har til bestillingen.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card rounded sh1 mb3 p3"
  }, [_c('md-input-container', [_c('label', [_vm._v("Merknader")]), _vm._v(" "), _c('md-textarea', {
    model: {
      value: (_vm.notes),
      callback: function($$v) {
        _vm.notes = $$v
      },
      expression: "notes"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step-number"
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('div', {
    staticClass: "fz24 light"
  }, [_vm._v("Levering")]), _vm._v(" "), _c('p', {
    staticClass: "mt2 mb3"
  }, [_vm._v("\n            Velg leveringsadresse for bestillingen.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card rounded sh1 mb3 p3"
  }, [_c('div', {
    staticClass: "clearfix mxn3"
  }, [_c('div', {
    staticClass: "col col-6 px3"
  }, [_c('div', {
    staticClass: "fz18 mb3"
  }, [_vm._v("Velg")]), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "delivery"
    }
  }, [_vm._v("Velg leveringsadresse")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "delivery",
      "id": "delivery"
    },
    model: {
      value: (_vm.deliveryAddress),
      callback: function($$v) {
        _vm.deliveryAddress = $$v
      },
      expression: "deliveryAddress"
    }
  }, [_c('md-subheader', [_vm._v("Standard leveringsadresse")]), _vm._v(" "), (_vm.user && _vm.user.store.post_address) ? _c('md-option', {
    attrs: {
      "value": -1
    }
  }, [_vm._v(_vm._s(_vm.user.store.post_address.name) + "\n                    ")]) : _vm._e(), _vm._v(" "), _c('md-subheader', [_vm._v("Alle leveringsadresser")]), _vm._v(" "), _vm._l((_vm.addresses), function(address, index) {
    return _c('md-option', {
      key: index,
      attrs: {
        "value": index
      }
    }, [_vm._v("\n                      " + _vm._s(address.address.name) + "\n                    ")])
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col col-6 px3"
  }, [_c('div', {
    staticClass: "fz18 mb3"
  }, [_vm._v("Valgt leveringsadresse:")]), _vm._v(" "), (_vm.user && _vm.user.store.post_address) ? _c('div', {
    staticClass: "bg-light-blue p3 rounded"
  }, [_c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Navn")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.selectedAddress.name))])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Adresse")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.selectedAddress.address))])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Postnummer")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.selectedAddress.zip))])]), _vm._v(" "), _c('div', {
    staticClass: "mb2"
  }, [_c('small', {
    staticClass: "text-grey"
  }, [_vm._v("Poststed")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.selectedAddress.city))])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step-number"
  }, [_vm._v("4")]), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('div', {
    staticClass: "fz24 light mb2"
  }, [_vm._v("Detaljer")]), _vm._v(" "), _c('div', {
    staticClass: "mb3"
  }, [_vm._v("\n            Fyll ut detaljene for bestillingen. Informasjonen blir kun brukt som intern referanse.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "card rounded sh1 mb3 p3"
  }, [_c('div', {
    staticClass: "fz18"
  }, [_vm._v("Bestilling")]), _vm._v(" "), _c('p', [_vm._v("\n              Gi bestillingen et navn. F.eks. \"Banner og beachflag til Firma AS\".\n            ")]), _vm._v(" "), _c('div', [_c('md-input-container', {
    class: {
      'md-input-invalid': _vm.errors.hasError('title')
    }
  }, [_c('label', [_vm._v("Navn på bestilling")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  }), _vm._v(" "), (_vm.errors.hasError('title')) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.errors.getFirstError('title')))]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "card rounded sh1 mb3 p3"
  }, [_c('div', {
    staticClass: "fz18"
  }, [_vm._v("Kundeopplysninger")]), _vm._v(" "), _c('p', [_vm._v("\n              Fyll inn detaljene til kunden du bestiller for.\n            ")]), _vm._v(" "), _c('div', [_c('md-input-container', [_c('label', [_vm._v("Navn/firma")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.data.client.name),
      callback: function($$v) {
        _vm.$set(_vm.data.client, "name", $$v)
      },
      expression: "data.client.name"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Telefon/mobil")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.data.client.phone),
      callback: function($$v) {
        _vm.$set(_vm.data.client, "phone", $$v)
      },
      expression: "data.client.phone"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("E-post")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.data.client.email),
      callback: function($$v) {
        _vm.$set(_vm.data.client, "email", $$v)
      },
      expression: "data.client.email"
    }
  })], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "step"
  }, [_c('div', {
    staticClass: "step-number"
  }, [_vm._v("5")]), _vm._v(" "), _c('div', {
    staticClass: "step-content"
  }, [_c('div', {
    staticClass: "fz24 light mb3"
  }, [_vm._v("Fullfør")]), _vm._v(" "), _c('div', {
    staticClass: "card rounded sh1 mb3 p3"
  }, [_c('div', {
    staticClass: "fz18"
  }, [_vm._v("Oppsummering")]), _vm._v(" "), _c('p', {
    staticClass: "mt2"
  }, [_vm._v("\n              Se over besillingen før du fullfører:\n            ")]), _vm._v(" "), _c('table', {
    staticClass: "cart-table",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_vm._l((_vm.$root.$data.cart.items), function(cartItem, index) {
    return _c('tr', {
      staticClass: "@bg-light-blue"
    }, [_c('td', {
      staticClass: "cell-image p2"
    }, [_c('img', {
      staticClass: "rounded pointer",
      attrs: {
        "src": _vm.getThumbnail(cartItem.product),
        "width": "80",
        "height": "80"
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz18 mb1"
    }, [_vm._v(_vm._s(cartItem.product.name))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(cartItem.parameters_text))])]), _vm._v(" "), _c('td', {
      staticClass: "center px3"
    }, [_vm._v("\n                  " + _vm._s(cartItem.quantity) + "\n                ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz24 light text-grey truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(cartItem.unit_price / 100)) + ",-")])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "fz24 light text-blue truncate"
    }, [_vm._v("kr " + _vm._s(_vm.toLocale(cartItem.total / 100)) + ",-")])])])
  }), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "border-top border-light-grey"
  }), _vm._v(" "), _c('td', {
    staticClass: "border-top border-light-grey"
  }), _vm._v(" "), _c('td', {
    staticClass: "border-top border-light-grey"
  }), _vm._v(" "), _c('td', {
    staticClass: "border-top border-light-grey"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-grey pt3 truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.$root.$data.cart.vat_total / 100)) + ",-\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("MVA")])]), _vm._v(" "), _c('td', {
    staticClass: "border-top border-light-grey pt3"
  }, [_c('div', {
    staticClass: "fz24 light mb1 text-blue truncate"
  }, [_vm._v("kr " + _vm._s(_vm.toLocale(_vm.$root.$data.cart.gross_total / 100)) + ",-\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "text-grey"
  }, [_vm._v("Total")])])])], 2)])]), _vm._v(" "), _vm._m(3), _vm._v(" "), (_vm.errors.hasErrors()) ? _c('div', {
    staticClass: "error-box p3 rounded sh1 mb3"
  }, [_c('div', {
    staticClass: "fz18 mb1"
  }, [_vm._v("Feil i felter")]), _vm._v(" "), _c('div', [_vm._v("Vennligst se over besillingen og prøv på nytt. Fant følgende feil i bestilling:")]), _vm._v(" "), _c('ul', {
    staticClass: "m0 mt2"
  }, _vm._l((_vm.errors.errors), function(error) {
    return _c('li', {
      staticClass: "fz16"
    }, [_vm._v(_vm._s(error[0]))])
  }))]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-success m0 px3 py1 mt2",
    attrs: {
      "disabled": _vm.state.is('ordering')
    },
    nativeOn: {
      "click": function($event) {
        _vm.placeOrder()
      }
    }
  }, [(_vm.state.is('ordering')) ? _c('span', [_vm._v("Plasserer din besilling...")]) : _c('span', [_vm._v("Fullfør og plasser bestilling")])])], 1)])])]) : _c('div', {
    staticClass: "p3 center"
  }, [_c('md-spinner', {
    attrs: {
      "md-indeterminate": ""
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey px3 py2 light left-align"
  }, [_vm._v("Produkt")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Antall")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Handlinger")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey px3 py2 light left-align"
  }, [_vm._v("Fil")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Handlinger")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-grey "
  }, [_c('th', {
    staticClass: "border-bottom border-light-grey "
  }), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align"
  }, [_vm._v("Produkt")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light"
  }, [_vm._v("Antall")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align"
  }, [_vm._v("Pris pr. stk.")]), _vm._v(" "), _c('th', {
    staticClass: "border-bottom border-light-grey py2 light left-align",
    attrs: {
      "light": ""
    }
  }, [_vm._v("Total")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card rounded sh1 mb3 p3"
  }, [_c('div', {
    staticClass: "fz18"
  }, [_vm._v("Betingelser")]), _vm._v(" "), _c('p', {
    staticClass: "mt2"
  }, [_vm._v("\n              Leveringstid er normalt 10-14 arbeidsdager. Alle bestillinger vil bli belastet med frakt og hånderingsgebyr\n              på 600 kr for mindre ordre (under 90x120x10 cm) og 1 200 kr for større ordre.\n            ")])])
}]}

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(304);
module.exports = __webpack_require__(303);


/***/ }),

/***/ 68:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);


/* harmony default export */ __webpack_exports__["a"] = ({
  isAuthenticated: function isAuthenticated() {
    return this.getToken() !== undefined;
  },
  authenticate: function authenticate(credentials) {
    var _this = this;

    return this.token(credentials).then(function (response) {
      __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('token', response.data.access_token, { expires: 7 });
      return response;
    }).catch(function (error) {
      _this.logout();
      throw error;
    });
  },
  logout: function logout() {
    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('token');
    __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove('cart');
  },
  getToken: function getToken() {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('token');
  },
  token: function token(payload) {
    return api.post('auth/token', payload);
  },
  refresh: function refresh(payload) {
    return api.post('auth/refresh', payload);
  },
  forgot: function forgot(payload) {
    return api.post('password/email', payload);
  },
  reset: function reset(payload) {
    return api.post('password/reset', payload);
  }
});

/***/ }),

/***/ 69:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/* global _ */

var Errors = function () {
  function Errors() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Errors);

    this.errors = {};
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Errors, [{
    key: "hasErrors",
    value: function hasErrors() {
      return !_.isEmpty(this.errors);
    }
  }, {
    key: "hasError",
    value: function hasError(key) {
      return this.errors[key] !== undefined;
    }
  }, {
    key: "getError",
    value: function getError(key) {
      return this.errors[key];
    }
  }, {
    key: "getFirstError",
    value: function getFirstError(key) {
      var error = this.getError(key);
      return error === undefined ? undefined : error[0];
    }
  }, {
    key: "setError",
    value: function setError(key, error) {
      this.errors[key] = error;
      return this;
    }
  }, {
    key: "setErrors",
    value: function setErrors(errors) {
      this.errors = errors;
      return this;
    }
  }, {
    key: "clearError",
    value: function clearError(key) {
      return this.setError(key, undefined);
    }
  }, {
    key: "clearErrors",
    value: function clearErrors() {
      this.errors = {};
      return this;
    }
  }]);

  return Errors;
}();

/* harmony default export */ __webpack_exports__["a"] = (Errors);

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var baseUri = 'cart-items';

/* harmony default export */ __webpack_exports__["a"] = ({
  store: function store(data) {
    return api.post('' + baseUri, data);
  },
  update: function update(id, data) {
    return api.patch(baseUri + '/' + id, data);
  },
  remove: function remove(id) {
    return api.delete(baseUri + '/' + id);
  }
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var baseUri = 'me';

/* harmony default export */ __webpack_exports__["a"] = ({
  show: function show() {
    return api.get(baseUri);
  },
  update: function update(data) {
    return api.patch(baseUri, data);
  }
});

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var baseUri = 'orders';

/* harmony default export */ __webpack_exports__["a"] = ({
  index: function index(query, limit, cancelToken) {
    return api.get(baseUri, {
      params: {
        query: query,
        limit: limit
      },
      cancelToken: cancelToken
    });
  },
  show: function show(id) {
    return api.get(baseUri + '/' + id);
  },
  dowload: function dowload(id) {
    return api.get(baseUri + '/' + id + '?format=pdf');
  },
  store: function store(data) {
    return api.post('' + baseUri, data);
  }
});

/***/ })

},[655]);


// WEBPACK FOOTER //
// static/js/app.c064b9ac15662f9b4c15.js